import axios from "axios";
import Config from "../../../config";
import {
  countriesList,
  getNotificationAlertPopUp,
  getUTCOffset,
  updatedCountriesList,
} from "../../constants";
import {
  setBrandChanged,
  setBrandsInChatWithData,
  setCancelSubscriptionLoader,
  setChatHistoryLoader,
  setChatsAnswerLoader,
  setChattopicsHistory,
  setChatWithDataResponse,
  setConcurrentLimitReached,
  setCreditLimitExhausted,
  setCreditsCountLoader,
  setDeleteAccountLoader,
  setDeleteAccountReasonList,
  setDurationChanged,
  setDurationInChatWithData,
  setFollowUpQuestionsLoader,
  setGetVisitorIdLoader,
  setLandingPageQuestionsList,
  setOtpStatusFlag,
  setOtpValidateLoader,
  setPaymentProcessLoader,
  setPlansList,
  setPlansListLoader,
  setSelectedChatData,
  setSignInThroughFlag,
  setSignUpLoader,
  setStarterQuestions,
  setStarterQuestionsLoader,
  setTopicAnswerLoader,
  setTopicAnswerOnScrollLoader,
  setTrendingSuggestionsList,
  setTrendingSuggestionsLoader,
  setUserProfileDetails,
  setUserProfileModalFlag,
  setUserProfileSaveLoader,
  setAuthLoader,
  setNegativeFeedbackReasonList,
  setGlobalSearchChatList,
  setGlobalSearchChatLoader,
  setShareChatID,
  setChatsStreamLoader,
  setSignUpFailedFlag,
  setChartsArtifactLoader,
  setPersona,
  setReasoningActive,
  setSSEStreaming,
  setFinalMetadataReceived,
  setShouldCollapseReasoning,
  resetStreamingStates,
  setContentStarted,
} from "./ChatWithData";
import { convertMarkdownToHTML } from "../../constants/ChatWithDataConst";
import { message } from "antd";
import moment from "moment";
import { v4 as uuid } from "uuid";
import { identifyUser, trackEvent } from "../../../components/utils/posthog";
import { useSelector } from "react-redux";
import { store } from "../../../redux/store";

// CMOVERSE product instance type (1 = CWD, 2 = CMOVERSE)
const INSTANCE_TYPE = 2;

// Get Chat Event Stream API - NEW
// Per-session abort controllers for parallel streaming
const sessionControllers = new Map(); // Map<sessionKey, { chatStream, chatArtifact, chatResponse, followUp }>

const getSessionControllers = (sessionKey) => {
  if (!sessionControllers.has(sessionKey)) {
    sessionControllers.set(sessionKey, {
      chatStream: null,
      chatArtifact: null,
      chatResponse: null,
      followUp: null,
    });
  }
  return sessionControllers.get(sessionKey);
};

const abortSessionControllers = (sessionKey) => {
  const controllers = sessionControllers.get(sessionKey);
  if (controllers) {
    if (controllers.chatStream) controllers.chatStream.abort();
    if (controllers.chatArtifact) controllers.chatArtifact.abort();
    if (controllers.chatResponse) controllers.chatResponse.abort();
    if (controllers.followUp) controllers.followUp.abort();
  }
};

export const MAX_SIMULTANEOUS_STREAMS = 2;

let isSessionExpiredPopupShown = false;

export const handleSessionExpiration = () => {
  // Check if OAuth login is in progress to avoid session expiration during OAuth flow
  const oauthInProgress = localStorage.getItem("oauth_login_in_progress");
  if (oauthInProgress === "true") {
    return; // Don't show session expired popup during OAuth flow
  }

  // Additional check: if URL contains p_token, don't trigger session expiration
  const urlParams = new URLSearchParams(window.location.search);
  const hasTokenInUrl = urlParams.get("p_token");
  if (hasTokenInUrl) {
    return; // Don't show session expired popup if token is in URL
  }

  // Check if user is a guest with visitor_id - don't trigger session expiration for guests
  const visitorId = localStorage.getItem("visitor_id");
  const pToken = localStorage.getItem("p_token");
  const visitorUuid = localStorage.getItem("visitor_uuid");
  
  if (!pToken && visitorId) {
    return; // Don't show session expired popup for guest users with visitor_id
  }

  // If on chat page without p_token, allow guest access (visitor session is being initialized or active)
  const isOnChatPage = window.location.pathname === "/chat-with-data" || 
                       window.location.pathname.startsWith("/share/id/");
  if (!pToken && isOnChatPage) {
    return; // Don't show session expired popup - allow guest access on chat pages
  }

  if (isSessionExpiredPopupShown) {
    return;
  }
  isSessionExpiredPopupShown = true;
  // Abort all session controllers
  sessionControllers.forEach((controllers) => {
    if (controllers.chatStream) controllers.chatStream.abort();
    if (controllers.chatArtifact) controllers.chatArtifact.abort();
    if (controllers.chatResponse) controllers.chatResponse.abort();
    if (controllers.followUp) controllers.followUp.abort();
  });
  sessionControllers.clear();

  getNotificationAlertPopUp(
    "Notification",
    "Session expired. Please sign in again",
    "error"
  );

  const keyToKeep = "visitor_uuid";
  const valueToKeep = localStorage.getItem(keyToKeep);

  localStorage.clear();

  if (valueToKeep !== null) {
    localStorage.setItem(keyToKeep, valueToKeep);
  }

  setTimeout(() => {
    window.location = "/sign-in";
  }, 1000);
};

export const getChatStreamTextResponseAPI = (
  payloadObj,
  generated_query_id
) => {
  const sessionKey = payloadObj?.session_id || payloadObj?.temp_session_id || 'default';
  const controllers = getSessionControllers(sessionKey);
  if (controllers.chatStream) {
    controllers.chatStream.abort();
  }
  controllers.chatStream = new AbortController();
  const { signal } = controllers.chatStream;
  return async (dispatch) => {
  let startTime = Date.now();

    dispatch(setChatsStreamLoader(true));
    let url = `${Config.config1.api_link}/chat-with-data/chat-stream-text`;
    let body = {
      question: payloadObj?.question,
      session_id: payloadObj?.session_id,
      p_token: payloadObj?.p_token,
      visitor_id: payloadObj?.p_token ? null : payloadObj?.visitor_id,
      query_id: generated_query_id,
  instance_type: INSTANCE_TYPE,
    };
    trackEvent("FR_CHAT_STREAM_TEXT_REQUEST", {
      query_id: generated_query_id,
      session_id: payloadObj?.session_id,
      visitor_id: payloadObj?.p_token ? null : payloadObj?.visitor_id,
      is_logged_in: !!payloadObj?.p_token,
    });
    try {
      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(body),
        signal,
      });

      if (!response.ok) {
        dispatch(setChatsStreamLoader(false));
        dispatch(setReasoningActive(false, generated_query_id));
        throw new Error("Failed to connect to stream");
      }

      // Set reasoning as active when stream starts
      dispatch(setReasoningActive(true, generated_query_id));

      const reader = response.body.getReader();
      const decoder = new TextDecoder();
      let receivedText = "";

      while (true) {
        const { done, value } = await reader.read();
        if (done) {
          dispatch(setChatsStreamLoader(false));
          dispatch(setReasoningActive(false, generated_query_id));
          break;
        }

        const chunk = decoder.decode(value, { stream: true });
        // console.log("🔹 Received chunk: ===>", chunk);

        // Process and update UI in real-time if needed
        receivedText += chunk;
        // New Logic
        const endTime = Date.now();
        let finalTIme = endTime - startTime;
        let tempTime = moment.duration(finalTIme);
        let reasoningTime = tempTime.minutes() + tempTime.seconds();

        let chatAnswerLoader = false;
        if (payloadObj?.chatWithDataRes?.data?.length) {
          let chatWithData = payloadObj?.chatWithDataRes?.data?.map((d) => {
            chatAnswerLoader = d?.loader;

            if (d?.query_id === generated_query_id) {
              if (!chunk?.includes("[END_OF_STREAM]")) {
                if (d?.reasoning?.length) {
                  // d.reasoning = [...d?.reasoning, chunk];
                  d.reasoning = d.reasoning += chunk;
                  d.reasoning_time = reasoningTime;
                } else {
                  // d.reasoning = [chunk];
                  d.reasoning = chunk;
                  d.reasoning_time = reasoningTime;
                }
              }
            }
            return d;
          });

          let obj = {
            persist_data: chatWithData,
            data: chatWithData,
            total_length: null,
          };

          // console.log("stop dispatch chatAnswerLoader=>", chatAnswerLoader);
          dispatch(setChatWithDataResponse(obj));
        }
      }
    } catch (error) {
      trackEvent("FR_CHAT_STREAM_TEXT_FAILURE", {
        query_id: generated_query_id,
        session_id: payloadObj?.session_id,
        error_message: error.message,
      });
      dispatch(setChatsStreamLoader(false));
      dispatch(setReasoningActive(false, generated_query_id));
      console.error("❌ Error fetching SSE:", error);
    }
  };
};

export const setSaveChatReasonAPI = (payloadObj) => {
  let errorMessage;

  return async (dispatch) => {
    let body = {
      p_token: payloadObj?.p_token,
      session_id: payloadObj?.session_id,
      query_id: payloadObj?.query_id,
  reason: payloadObj?.reason,
      instance_type: INSTANCE_TYPE,
    };

    let url = `${Config.config1.api_link}/chat-with-data/save-reason`;
    trackEvent("FR_SAVE_REASON_REQUEST", {
      session_id: payloadObj?.session_id,
      query_id: payloadObj?.query_id,
      reason_length: payloadObj?.reason?.length,
    });
    axios
      .post(url, body)
      .then((response) => {
        if (response?.data?.status === "successful") {
          trackEvent("FR_SAVE_REASON_SUCCESS", {
            session_id: payloadObj?.session_id,
            query_id: payloadObj?.query_id,
          });
          // console.log("set stream response", response);
        } else {
          trackEvent("FR_SAVE_REASON_FAILURE", {
            session_id: payloadObj?.session_id,
            query_id: payloadObj?.query_id,
            error_type: "server_error",
            error_message: response?.data?.message || "Failed to save reason",
            response_status: response?.data?.status,
          });
          // disabling notification for now temporarily
          // getNotificationAlertPopUp(
          //   "Notification",
          //   response?.data?.reffered_msg,
          //   "error"
          // );
        }
      })
      .catch((error) => {
        trackEvent("FR_SAVE_REASON_FAILURE", {
          p_token: payloadObj?.p_token,
          session_id: payloadObj?.session_id,
          query_id: payloadObj?.query_id,
          error_type: "catch_block",
          error_message: error.message,
          error_code: error.code,
        });
      });
  };
};

export const setSaveArtifactAPI = (payloadObj) => {
  let body = {
    p_token: payloadObj?.p_token,
    session_id: payloadObj?.session_id,
    query_id: payloadObj?.query_id,
  artifact_id: payloadObj?.artifact_id,
    instance_type: INSTANCE_TYPE,
  };

  let url = `${Config.config1.api_link}/chat-with-data/save-artifact`;
  trackEvent("FR_SAVE_ARTIFACT_REQUEST", {
    session_id: payloadObj?.session_id,
    query_id: payloadObj?.query_id,
    artifact_id: payloadObj?.artifact_id,
  });
  axios
    .post(url, body)
    .then((response) => {
      if (response?.data?.status === "successful") {
        // console.log("Artifact Saved");
        trackEvent("FR_SAVE_ARTIFACT_SUCCESS", {
          session_id: payloadObj?.session_id,
          query_id: payloadObj?.query_id,
          artifact_id: payloadObj?.artifact_id,
        });
      } else {
        // console.log("Artifact Not Saved");
        trackEvent("FR_SAVE_ARTIFACT_FAILURE", {
          session_id: payloadObj?.session_id,
          query_id: payloadObj?.query_id,
          artifact_id: payloadObj?.artifact_id,
          error_type: "server_error",
          error_message: response?.data?.message || "Failed to save artifact",
          response_status: response?.data?.status,
        });
      }
    })
    .catch((error) => {
      trackEvent("FR_SAVE_ARTIFACT_FAILURE", {
        session_id: payloadObj?.session_id,
        query_id: payloadObj?.query_id,
        artifact_id: payloadObj?.artifact_id,
        error_type: "catch_block",
        error_message: error.message,
        error_code: error.code,
      });
    });
};
function waitForLocalStorageItem(key, retries = 5, delay = 500) {
  return new Promise((resolve) => {
    const tryGet = (count) => {
      const value = localStorage.getItem(key);
      if (value !== null || count >= retries) {
        resolve(value);
      } else {
        setTimeout(() => tryGet(count + 1), delay);
      }
    };
    tryGet(0);
  });
}

// Chat With Data, Prompt Text API
let activeFollowUpQueries = new Set(); // Track active follow-up queries to prevent duplicates
// Profile fetch de-duplication & throttling
let profileFetchInFlight = null;
let lastProfileFetchTime = 0; // epoch ms
const PROFILE_FETCH_TTL = 5 * 60 * 1000; // 5 minutes

export const getChatResponseAPI = (payloadObj, shared_case) => {
  let errorMessage;
  let generated_query_id = uuid();
  const region = JSON.parse(localStorage.getItem("Region") || "false");

  return async (dispatch) => {
    // Use session key for per-session abort controller isolation
    const sessionKey = payloadObj?.session_id || payloadObj?.temp_session_id || 'default';

    // Abort previous controllers for THIS SESSION ONLY (not all sessions)
    abortSessionControllers(sessionKey);

    // Clear any pending follow-up queries when starting a new chat in this session
    activeFollowUpQueries.clear();

    // Create new controllers for this session
    const controllers = getSessionControllers(sessionKey);
    controllers.chatResponse = new AbortController();
    const { signal } = controllers.chatResponse;
    let chatWithData = payloadObj?.chatWithDataRes?.data?.map((d) => {
      // chartResponseLoader = d?.loader;
      d.chartCompLoader = false;
      return d;
    });

    let obj = {
      persist_data: chatWithData,
      data: chatWithData,
      total_length: null,
    };
    dispatch(setChatWithDataResponse(obj));
    // window.stop();
    let body = {
      session_id: payloadObj?.session_id,
      role: "user",
      content: payloadObj?.question,
      visitor_id: payloadObj?.p_token ? null : payloadObj?.visitor_id,
      p_token: payloadObj?.p_token,
      query_id: payloadObj?.query_id,
      utcoffset: getUTCOffset(),
  // Only send geo details when Region toggle is enabled (India vs Global selection)
  ip_address: region ? payloadObj?.ip_address : null,
  chat_country: region ? payloadObj?.chat_country : null,
  chat_country_code: region ? payloadObj?.chat_country_code : null,
      question_type: payloadObj?.question_type,
      instance_type: INSTANCE_TYPE,
      persona: payloadObj?.persona,
    };

    // Call Event Stream API - DISABLED: Now handled by reasoning_chunk in SSE
    // if (
    //   chatResponseController &&
    //   ((payloadObj?.p_token &&
    //     (payloadObj?.user_credit_count > 0 ||
    //       payloadObj?.is_subscription_active === "true")) ||
    //     !payloadObj?.p_token)
    // ) {
    //   dispatch(getChatStreamTextResponseAPI(payloadObj, payloadObj?.query_id));
    // }
    
    // DISABLED: Artifact stream API - artifacts are now received in the main streaming response
    // Call Artifact Stream API
    // if (
    //   // payloadObj?.p_token
    //   chatResponseController &&
    //   (payloadObj?.user_credit_count > 0 ||
    //     payloadObj?.is_subscription_active === "true") &&
    //   payloadObj?.p_token
    // ) {
    //   dispatch(
    //     getChartArtifactStreamResponse(payloadObj, payloadObj?.query_id)
    //   );
    // }

    dispatch(setChatsAnswerLoader(true));
    let url = `${Config.config1.api_link}/chat-with-data/chat`;
    trackEvent("FR_CHAT_RESPONSE_API_REQUEST", {
      query_id: payloadObj?.query_id,
      session_id: payloadObj?.session_id,
      is_logged_in: !!payloadObj?.p_token,
      visitor_id: payloadObj?.visitor_id,
      question_length: payloadObj?.question?.length,
      question_type: payloadObj?.question_type,
      instance_type: 1,
      ip_address: region ? payloadObj?.ip_address : null,
      chat_country: region ? payloadObj?.chat_country : null,
      chat_country_code: region ? payloadObj?.chat_country_code : null,
      instance_type: INSTANCE_TYPE,
      persona: payloadObj?.persona,
    });

    // Use SSE streaming instead of axios

    getAIResponseStreamSSE(payloadObj, body, dispatch)
      .then(({ content, metadata, reasoning }) => {
        // Transform SSE response to match existing response structure
        const response = {
          data: {
            status: metadata?.status || "successful",
            result: {
              bot_response_output: content,
              highcharts_config_json: null, // Not provided in new format
              is_visualization_used: false, // Not provided in new format
              chart_type: null,
              session_id: metadata?.result?.session_id || payloadObj.session_id,
              query_id: metadata?.result?.query_id || payloadObj.query_id,
              message: null,
              show_message: false,
              execution_time: metadata?.execution_time || 0,
              answered_at:
                metadata?.result?.answered_at || new Date().toISOString(),
            },
            credit_count:
              metadata?.credit_count !== undefined
                ? metadata.credit_count
                : payloadObj.user_credit_count,
            is_subscription_active:
              metadata?.is_subscription_active !== undefined
                ? metadata.is_subscription_active
                : payloadObj.is_subscription_active,
          },
        };

        // Update credit count and subscription status in localStorage
        if (metadata?.credit_count !== undefined) {
          localStorage.setItem("credit_count", metadata.credit_count);
        }
        if (metadata?.is_subscription_active !== undefined) {
          localStorage.setItem(
            "is_subscription_active",
            metadata.is_subscription_active
          );
        }

        // Now use the existing response handling code
        if (
          response?.data?.message ===
          "Credits exhausted. Please upgrade your current plan to continue."
        ) {
          trackEvent("FR_CHAT_RESPONSE_API_FAILURE", {
            query_id: payloadObj?.query_id,
            session_id: payloadObj?.session_id,
            error_type: "credits_exhausted",
            error_message: response.data.message,
          });

          // Enable pop up
          dispatch(setCreditLimitExhausted(true));

          // Get current state from store instead of using stale payloadObj data
          const creditExhaustedState = store.getState();
          const creditExhaustedChatData = creditExhaustedState.ChatWithData.chat_with_data_res.data;

          if (creditExhaustedChatData?.length) {
            let chatWithData = creditExhaustedChatData.map((d) => {
              if (d?.query_id === payloadObj?.query_id) {
                return {
                  ...d,
                  answer: "Credits exhausted. Please upgrade your current plan to continue.",
                  highcharts_config_json: null,
                  is_visualization_used: false,
                  loader: false,
                };
              }
              return d;
            });
            let obj = {
              persist_data: chatWithData,
              data: chatWithData,
              total_length: null,
            };
            dispatch(setChatWithDataResponse(obj));
          }
          dispatch(setChatsAnswerLoader(false));

          localStorage.setItem("credit_count", 0);
          localStorage.setItem("is_subscription_active", null);

          // getNotificationAlertPopUp(
          //   "Notification",
          //   response?.data?.message,
          //   "error"
          // );
        } else if (response?.data?.status === "successful") {
          trackEvent("FR_CHAT_RESPONSE_API_SUCCESS", {
            query_id: payloadObj?.query_id,
            session_id: response?.data?.result?.session_id,
            is_visualization_used:
              response?.data?.result?.is_visualization_used,
            chart_type: response?.data?.result?.chart_type,
            execution_time: response?.data?.execution_time,
            has_new_chart:
              (response?.data?.result?.highcharts_config_json?.length || 0) > 0,
            follow_up_triggered: true,
          });

          if (payloadObj?.chatWithDataRes?.data?.length) {
            const formattedReasoning = reasoning
              .trim() // Remove leading/trailing whitespace
              .replace(/^"|"$/g, "") // Remove surrounding quotes, if any
              .replace(/•/g, "*");
            // Update here logic

            let newAns = response?.data?.result?.bot_response_output;
            let newChart = response?.data?.result?.highcharts_config_json;

            var text = newAns;
            var html = convertMarkdownToHTML(text);
            newAns = html;

            // Handle both formats:
            // - New format: native JSON array (already parsed by axios)
            // - Legacy format: JSON string that needs parsing
            if (newChart && typeof newChart === 'string' && newChart.length) {
              try {
                let updatedString = newChart.replace(/'/g, '"');
                updatedString = updatedString.replace(/\bFalse\b/g, "false");
                updatedString = updatedString.replace(/\bTrue\b/g, "true");
                newChart = JSON.parse(updatedString);
              } catch (e) {
                newChart = null;
              }
            }

            // Strip [CHART:...] markers from displayed answer
            if (newAns) {
              newAns = newAns.replace(/\[CHART:[^\]]+\]/g, '');
              // Collapse 3+ consecutive blank lines to 2 (safe during streaming)
              newAns = newAns.replace(/\n{3,}/g, '\n\n');
            }

            // Reconstruct content_segments from [CHART:id] markers
            let contentSegments = null;
            if (Array.isArray(newChart) && newChart.length > 0 && text) {
              const chartMap = {};
              newChart.forEach(c => { if (c.id) chartMap[c.id] = c; });

              const parts = text.split(/\[CHART:([^\]]+)\]/);

              const segments = [];
              for (let i = 0; i < parts.length; i++) {
                if (i % 2 === 0) {
                  const trimmed = parts[i].trim();
                  if (trimmed) {
                    segments.push({
                      type: "text",
                      content: trimmed,
                      html: convertMarkdownToHTML(trimmed),
                    });
                  }
                } else {
                  const chartId = parts[i];
                  const chartConfig = chartMap[chartId];
                  if (chartConfig) {
                    segments.push({
                      type: "chart",
                      chartId: chartConfig.id,
                      chartTitle: chartConfig.description || chartConfig.config?.title?.text || "Chart",
                      charts: [chartConfig],
                    });
                  }
                }
              }

              if (segments.some(s => s.type === 'chart')) {
                contentSegments = segments;
              }
            }

            // Get current state from store instead of using stale payloadObj data
            const currentState = store.getState();
            const currentChatData = currentState.ChatWithData.chat_with_data_res.data;

            let chatWithData = currentChatData?.map((d) => {
              if (d?.query_id === payloadObj?.query_id) {
                return {
                  ...d,
                  answer: newAns,
                  reasoning: formattedReasoning,
                  highcharts_config_json: newChart,
                  ...(contentSegments ? { content_segments: contentSegments } : {}),
                  is_visualization_used:
                    response?.data?.result?.is_visualization_used,
                  loader: false,
                  chart_type: response?.data?.result?.chart_type,
                  session_id: response?.data?.result?.session_id,
                  query_id: payloadObj?.query_id,
                  feedback_type: null,
                  message: response?.data?.result?.message,
                  show_message: response?.data?.result?.show_message,
                  execution_time: response?.data?.execution_time,
                  answered_at: response?.data?.result?.answered_at,
                  // Mark streaming as complete
                  is_streaming: false,
                  is_sse_streaming: false,
                  // Follow-up questions come from SSE stream (follow_up_chunk events)
                };
              }
              return d;
            });

            let obj = {
              persist_data: chatWithData,
              data: chatWithData,
              total_length: null,
            };
            dispatch(setChatWithDataResponse(obj));

            // Call Api to get new session name
            if (payloadObj?.session_id === null || shared_case) {
              let obj = {
                authParams: payloadObj?.authParams,
                chatTopicsHistory: payloadObj?.chatTopicsHistory,
                session_id:
                  response?.data?.result?.session_id || payloadObj?.session_id,
                question: payloadObj?.question,
                answer: response?.data?.result?.bot_response_output,
                p_token: payloadObj?.p_token ? payloadObj?.p_token : null,
              };

              // DISABLED: Session name is now received in the streaming response
              // if (payloadObj?.p_token) {
              //   dispatch(getNewChatNameAPI(obj));
              // }
            }

            // Call Follow Up API - using hardcoded questions for now
            let followUpObj = {
              p_token: payloadObj?.p_token,
              query_id: response?.data?.result?.query_id || payloadObj?.query_id,
              question: payloadObj?.question,
              answer: response?.data?.result?.bot_response_output,
              chatWithDataRes: payloadObj?.chatWithDataRes,
              visitor_id: payloadObj?.visitor_id,
            };
            dispatch(getFollowUpQuestionsListAPI(followUpObj));
          }
          dispatch(setChatsAnswerLoader(false));

          localStorage.setItem("credit_count", response?.data?.credit_count);
          localStorage.setItem(
            "is_subscription_active",
            response?.data?.is_subscription_active
          );

          // Tp Show Refered Message to user
          if (
            response?.data?.reffered_credits_flag &&
            response?.data?.reffered_msg
          ) {
            getNotificationAlertPopUp(
              "Notification",
              response?.data?.reffered_msg,
              "success"
            );
          }

          // Save Reason API
          // if (payloadObj?.p_token && reasoning) {
          //   let rawReason =
          //     payloadObj?.chatWithDataRes?.data?.[
          //       payloadObj?.chatWithDataRes?.data?.length - 1
          //     ]?.reasoning || "";

          //   const sentenceRegex = /([^.!?]*[.!?]\*)/g;
          //   let completeSentences = [];
          //   let match;
          //   while ((match = sentenceRegex.exec(rawReason)) !== null) {
          //     completeSentences.push(match[1].trim());
          //   }

          //   let cleanedReason = completeSentences.join("\n");
          //   let reasonObj = {
          //     p_token: payloadObj?.p_token,
          //     session_id: response?.data?.result?.session_id,
          //     query_id: response?.data?.result?.query_id,
          //     reason: reasoning,
          //     // reason: cleanedReason || null,
          //   };
          //   if (reasonObj?.reason && reasonObj?.reason !== "null") {
          //     dispatch(setSaveChatReasonAPI(reasonObj));
          //     if (chatStreamController) {
          //       chatStreamController.abort();
          //       chatStreamController = null;
          //     }
          //     let updatedChatWithData = payloadObj?.chatWithDataRes?.data?.map(
          //       (d) => {
          //         if (d?.query_id === payloadObj?.query_id) {
          //           d.reasoning = cleanedReason;
          //         }
          //         return d;
          //       }
          //     );

          //     dispatch(
          //       setChatWithDataResponse({
          //         persist_data: updatedChatWithData,
          //         data: updatedChatWithData,
          //         total_length: null,
          //       })
          //     );
          //   }
          // }
          const formattedReasoning = reasoning
            .trim()
            .replace(/^"|"$/g, "")
            .replace(/•/g, "*");

          if (
            payloadObj?.p_token &&
            formattedReasoning &&
            formattedReasoning.trim() !== ""
          ) {
            // DISABLED: Reasoning is now saved during streaming
            // let reasonObj = {
            //   p_token: payloadObj?.p_token,
            //   session_id: response?.data?.result?.session_id,
            //   query_id: response?.data?.result?.query_id,
            //   reason: formattedReasoning,
            // };

            // dispatch(setSaveChatReasonAPI(reasonObj));

            // Clean up stream controller for this session
            const sessionCtrl = sessionControllers.get(sessionKey);
            if (sessionCtrl?.chatStream) {
              sessionCtrl.chatStream.abort();
              sessionCtrl.chatStream = null;
            }
          }
          waitForLocalStorageItem("artifactId", 5, 500).then((artifact_id) => {
            localStorage.removeItem("artifactId");

            if (artifact_id !== null) {
              let artifactObj = {
                p_token: payloadObj?.p_token,
                session_id: response?.data?.result?.session_id,
                query_id: response?.data?.result?.query_id,
                artifact_id: artifact_id,
              };
              setSaveArtifactAPI(artifactObj);
            }
          });
          if (payloadObj?.call_chat_history) {
            dispatch(getChatTopicHistoryAPI(payloadObj));
          }
        } else if (response?.data?.error_code == 401) {
          trackEvent("FR_CHAT_RESPONSE_API_FAILURE", {
            p_token: payloadObj?.p_token,
            query_id: payloadObj?.query_id,
            session_id: payloadObj?.session_id,
            error_type: "auth_error",
            error_message: "Session expired. Please sign in again",
            error_code: 401,
          });
          handleSessionExpiration();
          // getNotificationAlertPopUp(
          //   "Notification",
          //   "Session expired. Please sign in again",
          //   "error"
          // );
          // const keyToKeep = "visitor_uuid";
          // const valueToKeep = localStorage.getItem(keyToKeep); // Store the value

          // // clear local stoarge
          // localStorage.clear();

          // if (valueToKeep !== null) {
          //   localStorage.setItem(keyToKeep, valueToKeep); // Restore the key
          // }

          // // Redirect to sign-in page
          // setTimeout(() => {
          //   window.location = "/sign-in";
          // }, 3000);
        } else {
          trackEvent("FR_CHAT_RESPONSE_API_FAILURE", {
            p_token: payloadObj?.p_token,
            query_id: payloadObj?.query_id,
            session_id: payloadObj?.session_id,
            error_type: "server_error",
            error_message: response?.data?.message || "Something went wrong!",
            response_status: response?.data?.status,
          });
          
          // Get current state from store instead of using stale payloadObj data
          const errorState = store.getState();
          const errorChatData = errorState.ChatWithData.chat_with_data_res.data;
          
          if (errorChatData?.length) {
            let chatWithData = errorChatData.map((d) => {
              if (d?.query_id === payloadObj?.query_id) {
                return {
                  ...d,
                  answer: "Something went wrong!",
                  highcharts_config_json: null,
                  is_visualization_used: false,
                  loader: false,
                };
              }
              return d;
            });
            let obj = {
              persist_data: chatWithData,
              data: chatWithData,
              total_length: null,
            };
            dispatch(setChatWithDataResponse(obj));
          }
          dispatch(setChatsAnswerLoader(false));
        }

        dispatch(setBrandChanged(false));
        dispatch(setDurationChanged(false));

        // Save response to database after SSE completes
        // NOTE: Session saving is handled by the CMO backend in /chat-stream
        // after it reads the cached response from Redis. The /save-stream-response
        // endpoint does not exist in the backend.
        // if (metadata) {
        //   dispatch(saveResponseToDB(metadata, payloadObj));
        // }
      })
      .catch((error) => {
        dispatch(setChatsAnswerLoader(false));
        if (
          error.message == "Request aborted" ||
          error.code === "ECONNABORTED"
        ) {
          return;
        }

        // Handle concurrent limit error — remove the loading chat entry, don't show "Something went wrong!"
        if (error.concurrent_limit) {
          const concurrentState = store.getState();
          const concurrentChatData = concurrentState.ChatWithData.chat_with_data_res.data;

          if (concurrentChatData?.length) {
            // Remove the chat entry that was added for this query (it never started streaming)
            let filteredData = concurrentChatData.filter(
              (d) => d?.query_id !== payloadObj?.query_id
            );
            let obj = {
              persist_data: filteredData,
              data: filteredData,
              total_length: null,
            };
            dispatch(setChatWithDataResponse(obj));
          }
          return;
        }

        // If we get 504
        // Get current state from store instead of using stale payloadObj data
        const catchErrorState = store.getState();
        const catchErrorChatData = catchErrorState.ChatWithData.chat_with_data_res.data;

        if (catchErrorChatData?.length) {
          let chatWithData = catchErrorChatData.map((d) => {
            if (d?.query_id === payloadObj?.query_id) {
              return {
                ...d,
                answer: "Something went wrong!",
                highcharts_config_json: null,
                is_visualization_used: false,
                loader: false,
              };
            }
            return d;
          });

          let obj = {
            persist_data: [],
            data: [],
            total_length: null,
          };
          // let obj = {
          //   persist_data: chatWithData,
          //   data: chatWithData,
          //   total_length: null,
          // };
          dispatch(setChatWithDataResponse(obj));
        }

        // Dont Show Message Now
        // if (error.message !== "Request aborted") {
        //   callNotification(null, "error");
        // }
      });
  };
};

// New SSE Streaming Implementation
export const getAIResponseStreamSSE = (payloadObj, body, dispatch) => {
  return new Promise((resolve, reject) => {
    let accumulatedContent = "";
    let accumulatedReasoning = "";
    let reasoningActivated = false; // Track if reasoning box has been shown
    let accumulatedFollowUpQuestions = []; // Store follow-up questions from stream
    let sessionNameSummary = null; // Store session name from stream
    let reasoningStartTime = Date.now();
    let finalMetadata = null;

    // Inline chart streaming: segment accumulation for interleaved text + chart rendering
    let accumulatedSegments = [];
    let currentTextBuffer = "";
    let lastSegmentUpdateTime = 0;

    // Use the new /chat-stream endpoint format
    const region = JSON.parse(localStorage.getItem("Region") || "false");
    const ssePayload = {
      session_id: payloadObj.session_id || null,
      role: "user",
      content: payloadObj.question,
      // Region toggle: true → send actual country code, false → send "GLOBAL" for no filtering
      ip_address: region ? payloadObj.ip_address : null,
      visitor_id: payloadObj.p_token ? null : payloadObj.visitor_id,
      p_token: payloadObj.p_token,
      query_id: payloadObj.query_id,
      utcoffset: getUTCOffset(),
      chat_country: region ? payloadObj.chat_country : null,
      chat_country_code: region ? payloadObj.chat_country_code : "GLOBAL",
      question_type: payloadObj.question_type || "cached_question",
      instance_type: INSTANCE_TYPE,
  persona: payloadObj.persona, // pass selected persona to backend
    };

    // Establish SSE connection with query parameters
    fetch(
      `${Config.config1.api_link}/chat-with-data/chat-stream`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "text/event-stream",
        },
        body: JSON.stringify(ssePayload),
      }
    )
      .then(async (response) => {
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        // Check if the response is JSON (e.g., concurrent_limit error) instead of SSE
        const contentType = response.headers.get("content-type") || "";
        if (contentType.includes("application/json")) {
          const jsonData = await response.json();
          if (jsonData?.concurrent_limit || jsonData?.error_code === 6) {
            dispatch(setConcurrentLimitReached(true));
            const err = new Error(jsonData?.message || "Concurrent limit reached");
            err.concurrent_limit = true;
            reject(err);
            return;
          }
          // Other JSON error — reject with message
          const err = new Error(jsonData?.message || "Unexpected JSON response from stream endpoint");
          reject(err);
          return;
        }

        // Set SSE streaming active
        dispatch(setSSEStreaming(true, payloadObj.query_id));

        // Check if reasoning is active and set collapse flag
        const state = store.getState();
        const currentChat = state.ChatWithData.chat_with_data_res.data.find(
          (d) => d.query_id === payloadObj.query_id
        );

        if (currentChat?.is_reasoning_active) {
          dispatch(setShouldCollapseReasoning(true, payloadObj.query_id));
        }

        const reader = response.body.getReader();
        const decoder = new TextDecoder();
        let buffer = "";

        const processStream = async () => {
          try {
            while (true) {
              const { done, value } = await reader.read();

              if (done) {
                break;
              }

              // Decode chunk
              const chunk = decoder.decode(value, { stream: true });
              buffer += chunk;

              // Parse SSE events
              const lines = buffer.split("\n");
              buffer = lines.pop() || "";

              let currentEvent = null;

              for (const line of lines) {
                if (line.startsWith("event: ")) {
                  currentEvent = line.substring(7).trim();
                } else if (line.startsWith("data: ") && currentEvent) {
                  const dataStr = line.substring(6).trim();

                  if (dataStr) {
                    try {
                      const parsedData = JSON.parse(dataStr);

                      switch (currentEvent) {
                        case "pre_stream_metadata":
                          // Store session_id so session_summary_chunk can match
                          // the correct chat when updating the sidebar name
                          if (parsedData.session_id) {
                            payloadObj.session_id = parsedData.session_id;

                            // Update selectedChatData with real session_id so
                            // follow-up queries typed in the query box include it.
                            // Only update if user is still on the same session
                            // (matched by temp_session_id) to avoid overwriting
                            // when user switches chats via sidebar mid-stream.
                            const currentSelected = store.getState().ChatWithData.selected_chat_data;
                            if (currentSelected &&
                                currentSelected.temp_session_id === payloadObj.temp_session_id &&
                                !currentSelected.session_id) {
                              dispatch(setSelectedChatData({
                                ...currentSelected,
                                session_id: parsedData.session_id,
                              }));
                            }

                            // Also stamp session_id on chat items in chatWithDataRes
                            // so displayedChats fallback and follow-up buttons work
                            const metaState = store.getState();
                            const metaChatData = metaState.ChatWithData.chat_with_data_res.data;
                            if (metaChatData?.length) {
                              const updatedChats = metaChatData.map((d) =>
                                d.temp_session_id === payloadObj.temp_session_id && !d.session_id
                                  ? { ...d, session_id: parsedData.session_id }
                                  : d
                              );
                              dispatch(setChatWithDataResponse({
                                persist_data: updatedChats,
                                data: updatedChats,
                                total_length: null,
                              }));
                            }
                          }
                          break;

                        case "reasoning_chunk":
                          // Filter out raw JSON fragments that leak from LLM
                          // (e.g. {"reasoning": ...} or {"list_of_questions": ...})
                          // but allow normal text that may contain quotes from user's query
                          {
                            const chunk = parsedData.chunk || "";
                            const trimmed = chunk.trim();
                            const isJsonFragment = (
                              (trimmed.startsWith("{") && trimmed.includes(":")) ||
                              (trimmed.startsWith('"') && trimmed.endsWith('":')) ||
                              trimmed === "{" || trimmed === "}" ||
                              trimmed === '{"reasoning' || trimmed === '{"list_of_questions'
                            );
                            if (!isJsonFragment) {
                            // Only strip colons that are JSON artifacts (":"),
                            // not colons in natural text like "Note: the brand..."
                            let cleanedChunk = chunk;
                            accumulatedReasoning += cleanedChunk;

                            // Show reasoning box and start typewriter only when
                            // we have enough text for immediate visible content
                            if (accumulatedReasoning.trim().length > 10) {
                              if (!reasoningActivated) {
                                reasoningActivated = true;
                                dispatch(
                                  setReasoningActive(true, payloadObj.query_id)
                                );
                              }
                              updateStreamingReasoning(
                                dispatch,
                                payloadObj,
                                accumulatedReasoning,
                                reasoningStartTime
                              );
                            }
                            }
                          }
                          break;

                        case "content_chunk":
                          // Mark content as started when first content_chunk arrives
                          if (accumulatedContent.length === 0) {
                            // Mark reasoning as complete and let it finish naturally
                            markReasoningStreamingComplete(payloadObj.query_id, null);
                            
                            dispatch(
                              setContentStarted(true, payloadObj.query_id)
                            );
                          }

                          accumulatedContent += parsedData.chunk;
                          // Track text buffer for segment accumulation
                          currentTextBuffer += parsedData.chunk;

                          // Mark reasoning as inactive when content starts streaming
                          dispatch(
                            setReasoningActive(false, payloadObj.query_id)
                          );

                          // Update UI with streaming content
                          if (accumulatedSegments.length > 0) {
                            // Charts exist — Chats.js renders from content_segments,
                            // NOT el.answer. Update segments on every chunk so text
                            // after charts is immediately visible.
                            const liveSegments = [...accumulatedSegments];
                            if (currentTextBuffer.trim()) {
                              liveSegments.push({
                                type: "text",
                                content: currentTextBuffer,
                                html: convertMarkdownToHTML(currentTextBuffer),
                              });
                            }
                            // Single dispatch: update both answer (for copy/export)
                            // and content_segments (for rendering) together
                            const html = convertMarkdownToHTML(accumulatedContent);
                            const currentState = store.getState();
                            const currentChatData =
                              currentState.ChatWithData.chat_with_data_res.data;
                            if (currentChatData?.length) {
                              const htmlSegments = liveSegments.map((seg) => {
                                if (seg.type === "text" && !seg.html) {
                                  return {
                                    ...seg,
                                    html: convertMarkdownToHTML(seg.content),
                                  };
                                }
                                return seg;
                              });
                              let chatWithData = currentChatData.map((d) => {
                                if (d.query_id === payloadObj.query_id) {
                                  return {
                                    ...d,
                                    answer: html,
                                    content_segments: htmlSegments,
                                    is_streaming: true,
                                    loader: false,
                                  };
                                }
                                return d;
                              });
                              dispatch(
                                setChatWithDataResponse({
                                  persist_data: chatWithData,
                                  data: chatWithData,
                                  total_length: null,
                                })
                              );
                            }
                          } else {
                            // No charts yet — use typewriter for smooth
                            // character-by-character rendering via el.answer
                            updateStreamingContent(
                              dispatch,
                              payloadObj,
                              accumulatedContent
                            );
                          }
                          break;

                        case "chart_chunk":
                          // Inline chart streaming: flush text buffer and add chart segment
                          try {
                            // Flush any accumulated text as a text segment
                            if (currentTextBuffer.trim()) {
                              accumulatedSegments.push({
                                type: "text",
                                content: currentTextBuffer,
                              });
                            }
                            // Always clear the buffer (even if whitespace-only) to prevent duplication
                            currentTextBuffer = "";

                            // Add chart segment — supports both legacy format and
                            // pre-built config format from the backend
                            const charts = parsedData.charts || [];
                            const firstChart = charts[0];
                            accumulatedSegments.push({
                              type: "chart",
                              chartId:
                                parsedData.chart_id ||
                                firstChart?.id ||
                                `chart-${accumulatedSegments.length}`,
                              chartTitle:
                                parsedData.chart_title ||
                                firstChart?.description ||
                                firstChart?.config?.title?.text ||
                                "Chart",
                              charts,
                            });

                            // Update segments on the chat object
                            updateStreamingSegments(
                              dispatch,
                              payloadObj,
                              accumulatedSegments
                            );
                          } catch (chartError) {
                            // Malformed chart data — skip segment, continue streaming
                            if (process.env.NODE_ENV === "development") {
                              console.error("[SSE] Malformed chart_chunk data:", chartError, parsedData);
                            }
                          }
                          break;

                        case "follow_up_chunk":
                          // Handle follow-up question chunks from stream
                          if (parsedData.question) {
                            // Add question at the specified index
                            const index = parsedData.index !== undefined ? parsedData.index : accumulatedFollowUpQuestions.length;
                            accumulatedFollowUpQuestions[index] = parsedData.question;
                            
                            // Update UI with accumulated follow-up questions
                            updateFollowUpQuestions(
                              dispatch,
                              payloadObj,
                              [...accumulatedFollowUpQuestions].filter(q => q) // Filter out any undefined entries
                            );
                          }
                          break;

                        case "session_summary_chunk":
                          // Handle session name summary from stream
                          if (parsedData.session_name_summary) {
                            sessionNameSummary = parsedData.session_name_summary;

                            // Update payloadObj with session_id if it comes in this chunk or from earlier metadata
                            const sessionIdToUse = parsedData.session_id || finalMetadata?.result?.session_id || payloadObj.session_id;

                            const updatedPayloadObj = {
                              ...payloadObj,
                              session_id: sessionIdToUse,
                            };

                            // Update the chat session name in the sidebar
                            updateSessionName(dispatch, updatedPayloadObj, sessionNameSummary);

                            // Persist session name to DB so it survives page refresh
                            if (sessionIdToUse && sessionNameSummary) {
                              const renameUrl = `${Config.config1.api_link}/chat-with-data/cwd-rename-session`;
                              axios.post(renameUrl, {
                                p_token: payloadObj.p_token,
                                session_name: sessionNameSummary,
                                session_id: sessionIdToUse,
                                instance_type: INSTANCE_TYPE,
                              }).catch(() => {});
                            }
                          }
                          break;

                        case "final_metadata":
                          finalMetadata = parsedData;

                          // Mark that final metadata has been received
                          dispatch(
                            setFinalMetadataReceived(true, payloadObj.query_id)
                          );
                          break;

                        case "stream_complete":
                          // If final_metadata already arrived, resolve now.
                          // UIL backend sends: final_metadata → stream_complete (no end_metadata).
                          // Without this, the promise never resolves and the chat resets.
                          if (!finalMetadata) break;
                          // Fall through to end_metadata logic
                        // eslint-disable-next-line no-fallthrough
                        case "end_metadata":
                          // end_metadata carries its own payload; stream_complete reuses finalMetadata
                          if (currentEvent === "end_metadata") {
                            finalMetadata = parsedData;
                          }

                          // Flush remaining text buffer as final segment
                          if (currentTextBuffer.trim()) {
                            accumulatedSegments.push({
                              type: "text",
                              content: currentTextBuffer,
                            });
                            currentTextBuffer = "";
                          }

                          // Store finalized segments on the chat object
                          if (accumulatedSegments.length > 0) {
                            updateStreamingSegments(
                              dispatch,
                              payloadObj,
                              accumulatedSegments
                            );
                          }

                          // Mark reasoning as complete (let typewriter finish naturally)
                          markReasoningStreamingComplete(payloadObj.query_id, null);

                          // Mark content streaming as complete and wait for typewriter to finish
                          markContentStreamingComplete(payloadObj.query_id, () => {
                            // This callback runs when typewriter catches up
                            // Mark that final metadata has been received
                            dispatch(
                              setFinalMetadataReceived(true, payloadObj.query_id)
                            );

                            // Mark SSE streaming as complete
                            dispatch(setSSEStreaming(false, payloadObj.query_id));

                            // Mark reasoning as inactive
                            dispatch(
                              setReasoningActive(false, payloadObj.query_id)
                            );

                            // Use accumulated follow-up questions from stream (if any)
                            if (accumulatedFollowUpQuestions.length > 0) {
                              updateFollowUpQuestions(
                                dispatch,
                                payloadObj,
                                [...accumulatedFollowUpQuestions].filter(q => q)
                              );
                            }

                            resolve({
                              content: accumulatedContent,
                              metadata: finalMetadata,
                              reasoning: accumulatedReasoning,
                            });
                          });
                          return;
                        case "error":
                          // Force flush on error - stop typewriter immediately
                          forceFlushReasoning(payloadObj.query_id);
                          forceFlushContent(payloadObj.query_id);

                          dispatch(setSSEStreaming(false, payloadObj.query_id));
                          dispatch(
                            setReasoningActive(false, payloadObj.query_id)
                          );

                          // Handle concurrent limit error from SSE error event
                          if (parsedData?.concurrent_limit || parsedData?.error_code === 6) {
                            dispatch(setConcurrentLimitReached(true));
                            const concurrentErr = new Error(parsedData?.message || "Concurrent limit reached");
                            concurrentErr.concurrent_limit = true;
                            reject(concurrentErr);
                            return;
                          }

                          trackEvent("FR_CHAT_STREAM_ERROR", {
                            query_id: payloadObj?.query_id,
                            session_id: payloadObj?.session_id,
                            error_data: parsedData,
                            error_type: "sse_error_event",
                          });
                          reject(
                            new Error(
                              parsedData?.message ||
                                "SSE stream error event received"
                            )
                          );
                          return;

                        case "analyst_response":
                          // DISABLED: Reasoning is now saved during streaming on backend
                          // if (payloadObj?.session_id) {
                          //   let reasonObj = {
                          //     p_token: payloadObj?.p_token,
                          //     session_id: payloadObj?.session_id,
                          //     query_id: payloadObj?.query_id,
                          //     reason: parsedData.agent_response.reasoning,
                          //   };
                          //   dispatch(setSaveChatReasonAPI(reasonObj));
                          // }
                          break;
                        default:
                      }
                    } catch (e) {
                      if (process.env.NODE_ENV === "development") {
                        console.warn("[SSE] Failed to parse event data:", dataStr?.substring(0, 100), e.message);
                      }
                    }
                  }
                } else if (line.includes("ping")) {
                }
              }
            }
          } catch (error) {
            // Stream ended — if we already have finalMetadata, treat as success
            // (AWA backend may close connection after streaming without end_metadata)
            if (finalMetadata) {
              forceFlushReasoning(payloadObj.query_id);
              forceFlushContent(payloadObj.query_id);
              dispatch(setFinalMetadataReceived(true, payloadObj.query_id));
              dispatch(setSSEStreaming(false, payloadObj.query_id));
              dispatch(setReasoningActive(false, payloadObj.query_id));
              if (accumulatedFollowUpQuestions.length > 0) {
                updateFollowUpQuestions(dispatch, payloadObj,
                  [...accumulatedFollowUpQuestions].filter(q => q));
              }
              resolve({
                content: accumulatedContent,
                metadata: finalMetadata,
                reasoning: accumulatedReasoning,
              });
            } else {
              dispatch(setSSEStreaming(false, payloadObj.query_id));
              reject(error);
            }
          }
        };

        processStream();
      })
      .catch((error) => {
        // Clean up streaming states on error
        dispatch(setSSEStreaming(false, payloadObj.query_id));
        reject(error);
      });
  });
};

// Per-query typewriter state for parallel streaming support
// Each query_id gets its own independent typewriter instance
const contentTypewriters = new Map(); // Map<query_id, { interval, displayedLength, streamingComplete, callback, pendingData, startTime }>
const reasoningTypewriters = new Map(); // Map<query_id, { interval, displayedLength, streamingComplete, callback, pendingData, startTime }>

const CHARS_PER_UPDATE = 3;
const TYPEWRITER_SPEED = 10;
const REASONING_CHARS_PER_UPDATE = 3;
const REASONING_TYPEWRITER_SPEED = 10;

// Track visibility changes to catch up when tab becomes visible
if (typeof document !== 'undefined') {
  document.addEventListener('visibilitychange', () => {
    if (!document.hidden) {
      // Tab became visible - catch up all typewriters instantly
      contentTypewriters.forEach((tw, queryId) => {
        if (tw.interval && tw.pendingData && tw.startTime) {
          const elapsedTime = Date.now() - tw.startTime;
          const expectedLength = Math.floor((elapsedTime / TYPEWRITER_SPEED) * CHARS_PER_UPDATE);
          const targetLength = Math.min(expectedLength, tw.pendingData.content.length);
          
          if (targetLength > tw.displayedLength) {
            tw.displayedLength = targetLength;
            // Snap to word boundary (max 40 chars to avoid jumps on URLs/hashtags)
            const c = tw.pendingData.content;
            const snapStart = tw.displayedLength;
            while (tw.displayedLength < c.length && c[tw.displayedLength] !== ' ' && c[tw.displayedLength] !== '\n') {
              if (tw.displayedLength - snapStart >= 40) break;
              tw.displayedLength++;
            }
            performContentUpdate(tw.pendingData.dispatch, tw.pendingData.payloadObj, c.substring(0, tw.displayedLength));
          }
        }
      });
      
      reasoningTypewriters.forEach((tw, queryId) => {
        if (tw.interval && tw.pendingData && tw.startTime) {
          const elapsedTime = Date.now() - tw.startTime;
          const expectedLength = Math.floor((elapsedTime / REASONING_TYPEWRITER_SPEED) * REASONING_CHARS_PER_UPDATE);
          const targetLength = Math.min(expectedLength, tw.pendingData.reasoning.length);

          if (targetLength > tw.displayedLength) {
            tw.displayedLength = targetLength;
            // Snap to word boundary (max 40 chars to avoid jumps on URLs/hashtags)
            const r = tw.pendingData.reasoning;
            const snapStart = tw.displayedLength;
            while (tw.displayedLength < r.length && r[tw.displayedLength] !== ' ' && r[tw.displayedLength] !== '\n') {
              if (tw.displayedLength - snapStart >= 40) break;
              tw.displayedLength++;
            }
            performReasoningUpdate(tw.pendingData.dispatch, tw.pendingData.payloadObj, r.substring(0, tw.displayedLength), tw.pendingData.startTime);
          }
        }
      });
    }
  });
}

const getContentTypewriter = (queryId) => {
  if (!contentTypewriters.has(queryId)) {
    contentTypewriters.set(queryId, {
      interval: null,
      displayedLength: 0,
      streamingComplete: false,
      callback: null,
      pendingData: null,
      startTime: null,
    });
  }
  return contentTypewriters.get(queryId);
};

const getReasoningTypewriter = (queryId) => {
  if (!reasoningTypewriters.has(queryId)) {
    reasoningTypewriters.set(queryId, {
      interval: null,
      displayedLength: 0,
      streamingComplete: false,
      callback: null,
      pendingData: null,
      startTime: null,
    });
  }
  return reasoningTypewriters.get(queryId);
};

const updateStreamingContent = (dispatch, payloadObj, content) => {
  const queryId = payloadObj.query_id;
  const tw = getContentTypewriter(queryId);
  tw.pendingData = { dispatch, payloadObj, content };

  if (!tw.interval) {
    tw.displayedLength = 0;
    tw.streamingComplete = false;
    tw.startTime = Date.now(); // Track when typewriter started

    // Use setInterval - will be throttled in background but we catch up on visibility change
    tw.interval = setInterval(() => {
      if (!tw.pendingData) {
        clearInterval(tw.interval);
        tw.interval = null;
        return;
      }

      const { dispatch, payloadObj, content } = tw.pendingData;

      // Calculate where we should be based on elapsed time (handles background throttling)
      const elapsedTime = Date.now() - tw.startTime;
      const expectedLength = Math.floor((elapsedTime / TYPEWRITER_SPEED) * CHARS_PER_UPDATE);
      const targetLength = Math.min(expectedLength, content.length);
      
      // Jump to where we should be (catches up if throttled)
      if (targetLength > tw.displayedLength) {
        tw.displayedLength = targetLength;
      } else {
        // Normal increment if we're on track
        tw.displayedLength = Math.min(tw.displayedLength + CHARS_PER_UPDATE, content.length);
      }
      
      // Snap forward to next word boundary to avoid cutting markdown mid-word
      // Max snap of 40 chars to avoid visible jumps on long unbroken strings
      if (tw.displayedLength < content.length) {
        const snapStart = tw.displayedLength;
        while (tw.displayedLength < content.length && content[tw.displayedLength] !== ' ' && content[tw.displayedLength] !== '\n') {
          if (tw.displayedLength - snapStart >= 40) break;
          tw.displayedLength++;
        }
      }

      const displayContent = content.substring(0, tw.displayedLength);
      performContentUpdate(dispatch, payloadObj, displayContent);

      if (tw.streamingComplete && tw.displayedLength >= content.length) {
        clearInterval(tw.interval);
        tw.interval = null;
        tw.pendingData = null;
        tw.displayedLength = 0;
        tw.streamingComplete = false;
        tw.startTime = null;
        contentTypewriters.delete(queryId);

        if (tw.callback) {
          tw.callback();
          tw.callback = null;
        }
      }
    }, TYPEWRITER_SPEED);
  }
};

// Update content_segments on the chat object for inline chart rendering.
// Text segments are stored with pre-converted HTML to avoid a visual flash
// when switching from the typewriter-rendered answer to segment-based rendering.
const updateStreamingSegments = (dispatch, payloadObj, segments) => {
  const currentState = store.getState();
  const currentChatData = currentState.ChatWithData.chat_with_data_res.data;

  if (currentChatData?.length) {
    // Pre-convert text segments to HTML for consistent rendering
    const htmlSegments = segments.map((seg) => {
      if (seg.type === "text") {
        return { ...seg, html: convertMarkdownToHTML(seg.content) };
      }
      return seg;
    });

    let chatWithData = currentChatData.map((d) => {
      if (d.query_id === payloadObj.query_id) {
        return {
          ...d,
          content_segments: htmlSegments,
          // Ensure answer branch activates when charts arrive before text
          answer: d.answer || "",
          loader: false,
        };
      }
      return d;
    });

    dispatch(
      setChatWithDataResponse({
        persist_data: chatWithData,
        data: chatWithData,
        total_length: null,
      })
    );
  }
};

const markContentStreamingComplete = (queryId, callback) => {
  const tw = contentTypewriters.get(queryId);
  if (tw) {
    tw.streamingComplete = true;
    tw.callback = callback;

    if (!tw.interval && callback) {
      callback();
      tw.callback = null;
      contentTypewriters.delete(queryId);
    }
  } else if (callback) {
    callback();
  }
};

const forceFlushContent = (queryId) => {
  const tw = contentTypewriters.get(queryId);
  if (tw) {
    if (tw.interval) {
      clearInterval(tw.interval);
      tw.interval = null;
    }
    if (tw.pendingData) {
      const { dispatch, payloadObj, content } = tw.pendingData;
      performContentUpdate(dispatch, payloadObj, content);
    }
    contentTypewriters.delete(queryId);
  }
};

const performContentUpdate = (dispatch, payloadObj, content) => {
  const html = convertMarkdownToHTML(content);

  const currentState = store.getState();
  const currentChatData = currentState.ChatWithData.chat_with_data_res.data;

  if (currentChatData?.length) {
    let chatWithData = currentChatData.map((d) => {
      if (d.query_id === payloadObj.query_id) {
        return {
          ...d,
          answer: html,
          is_streaming: true,
          loader: false,
        };
      }
      return d;
    });

    dispatch(
      setChatWithDataResponse({
        persist_data: chatWithData,
        data: chatWithData,
        total_length: null,
      })
    );
  }
};

const updateStreamingReasoning = (dispatch, payloadObj, reasoning, startTime) => {
  const queryId = payloadObj.query_id;
  const tw = getReasoningTypewriter(queryId);
  tw.pendingData = { dispatch, payloadObj, reasoning, startTime };

  if (!tw.interval) {
    tw.displayedLength = 0;
    tw.streamingComplete = false;
    tw.startTime = Date.now(); // Track when typewriter started

    // Use setInterval - will be throttled in background but we catch up on visibility change
    tw.interval = setInterval(() => {
      if (!tw.pendingData) {
        clearInterval(tw.interval);
        tw.interval = null;
        return;
      }

      const { dispatch, payloadObj, reasoning, startTime } = tw.pendingData;

      // Calculate where we should be based on elapsed time (handles background throttling)
      const elapsedTime = Date.now() - tw.startTime;
      const expectedLength = Math.floor((elapsedTime / REASONING_TYPEWRITER_SPEED) * REASONING_CHARS_PER_UPDATE);
      const targetLength = Math.min(expectedLength, reasoning.length);
      
      // Jump to where we should be (catches up if throttled)
      if (targetLength > tw.displayedLength) {
        tw.displayedLength = targetLength;
      } else {
        // Normal increment if we're on track
        tw.displayedLength = Math.min(tw.displayedLength + REASONING_CHARS_PER_UPDATE, reasoning.length);
      }

      // Snap forward to next word boundary to avoid cutting words/markdown mid-token
      // e.g. "**Air India**" should never render as "**Air" (broken bold)
      // Max snap of 40 chars to avoid visible jumps on long unbroken strings (URLs, hashtags)
      if (tw.displayedLength < reasoning.length) {
        const snapStart = tw.displayedLength;
        while (tw.displayedLength < reasoning.length && reasoning[tw.displayedLength] !== ' ' && reasoning[tw.displayedLength] !== '\n') {
          if (tw.displayedLength - snapStart >= 40) break;
          tw.displayedLength++;
        }
      }

      const displayReasoning = reasoning.substring(0, tw.displayedLength);
      performReasoningUpdate(dispatch, payloadObj, displayReasoning, startTime);

      if (tw.streamingComplete && tw.displayedLength >= reasoning.length) {
        clearInterval(tw.interval);
        tw.interval = null;
        tw.pendingData = null;
        tw.displayedLength = 0;
        tw.streamingComplete = false;
        tw.startTime = null;
        reasoningTypewriters.delete(queryId);

        if (tw.callback) {
          tw.callback();
          tw.callback = null;
        }
      }
    }, REASONING_TYPEWRITER_SPEED);
  }
};

const markReasoningStreamingComplete = (queryId, callback) => {
  const tw = reasoningTypewriters.get(queryId);
  if (tw) {
    tw.streamingComplete = true;
    tw.callback = callback;

    if (!tw.interval && callback) {
      callback();
      tw.callback = null;
      reasoningTypewriters.delete(queryId);
    }
  } else if (callback) {
    callback();
  }
};

const forceFlushReasoning = (queryId) => {
  const tw = reasoningTypewriters.get(queryId);
  if (tw) {
    if (tw.interval) {
      clearInterval(tw.interval);
      tw.interval = null;
    }
    if (tw.pendingData) {
      const { dispatch, payloadObj, reasoning, startTime } = tw.pendingData;
      performReasoningUpdate(dispatch, payloadObj, reasoning, startTime);
    }
    reasoningTypewriters.delete(queryId);
  }
};

const performReasoningUpdate = (dispatch, payloadObj, reasoning, startTime) => {
  const currentTime = Date.now();
  const elapsedTime = currentTime - startTime;
  const duration = moment.duration(elapsedTime);
  const reasoningTime = Math.floor(duration.asSeconds());

  const currentState = store.getState();
  const currentChatData = currentState.ChatWithData.chat_with_data_res.data;

  if (currentChatData?.length) {
    let chatWithData = currentChatData.map((d) => {
      if (d.query_id === payloadObj.query_id) {
        return {
          ...d,
          reasoning: reasoning,
          reasoning_time: reasoningTime,
        };
      }
      return d;
    });

    dispatch(
      setChatWithDataResponse({
        persist_data: chatWithData,
        data: chatWithData,
        total_length: null,
      })
    );
  }
};

// Helper function to update follow-up questions
const updateFollowUpQuestions = (dispatch, payloadObj, followUpQuestions) => {
  // Get current state from store
  const currentState = store.getState();
  const currentChatData = currentState.ChatWithData.chat_with_data_res.data;

  if (currentChatData?.length) {
    let chatWithData = currentChatData.map((d) => {
      if (d.query_id === payloadObj.query_id) {
        return {
          ...d,
          follow_up_questions_list: followUpQuestions,
        };
      }
      return d;
    });

    dispatch(
      setChatWithDataResponse({
        persist_data: chatWithData,
        data: chatWithData,
        total_length: null,
      })
    );
  }
};

// Helper function to update session name from stream
const updateSessionName = (dispatch, payloadObj, sessionName) => {
  // Get current state from store
  const currentState = store.getState();
  const chatTopicsHistory = currentState.ChatWithData.chat_topics_history;
  
  if (chatTopicsHistory?.data?.length) {
    // Find and update the correct session by matching session_id or temp_session_id
    let updated = false;
    let updatedHistory = chatTopicsHistory.data.map((group) => {
      return {
        ...group,
        content: group.content.map((chat) => {
          // Priority 1: Match by session_id (most reliable for existing sessions)
          if (payloadObj.session_id && chat.session_id === payloadObj.session_id) {
            updated = true;
            return {
              ...chat,
              session_name: sessionName,
            };
          }

          // Priority 2: For new sessions — the sidebar chat has session_id: null
          // but payloadObj now has session_id from pre_stream_metadata.
          // Match by temp_session_id and also set the real session_id.
          if (payloadObj.temp_session_id &&
              chat.temp_session_id === payloadObj.temp_session_id) {
            updated = true;
            return {
              ...chat,
              session_name: sessionName,
              session_id: payloadObj.session_id || chat.session_id,
            };
          }

          return chat;
        }),
      };
    });

    if (updated) {
      dispatch(setChattopicsHistory({
        ...chatTopicsHistory,
        data: updatedHistory,
      }));
    }
  }
};

// Database save function for SSE response
export const saveResponseToDB = (metadata, payloadObj) => {
  return async (dispatch) => {
    try {
      const url = `${Config.config1.api_link}/chat-with-data/save-stream-response`;
      const response = await axios.post(url, {
        query_id: metadata.query_id,
        session_id: metadata.session_id,
        response_data: metadata.bot_response_output,
        metadata: {
          tokens_usage: metadata.tokens_usage,
          agents_info: metadata.agents_info,
          query_list: metadata.query_list,
          questions_generated: metadata.questions_generated,
          is_visualization_used: metadata.is_visualization_used,
          df_data: metadata.df_data,
        },
        user_info: {
          p_token: payloadObj.p_token,
          visitor_id: payloadObj.visitor_id,
          ip_address: payloadObj.ip_address,
        },
        instance_type: INSTANCE_TYPE,
      });

      if (response.data.status === "successful") {
        console.log("[saveResponseToDB] Saved successfully:", metadata.session_id);
      } else {
        console.warn("[saveResponseToDB] Save failed:", response.data);
      }
    } catch (error) {
      console.error("[saveResponseToDB] Error:", error?.response?.status, error?.message);
    }
  };
};

// Get Chat Topics History List
export const getChatTopicHistoryAPI = (payloadObj) => {
  let errorMessage;
  return async (dispatch) => {
    let body = {
      offset: payloadObj?.offset || 0,
      session_id: payloadObj?.session_id,
      p_token: payloadObj?.p_token,
      utcoffset: getUTCOffset(),
      instance_type: INSTANCE_TYPE,
    };

    if (payloadObj?.offset === 0) {
      dispatch(setChatHistoryLoader(true));
    }
    let url = `${Config.config1.api_link}/chat-with-data/cwd-hist-list`;
    axios
      .post(url, body)
      .then((response) => {
        let timer = null;
        if (response?.data?.error_code == 401) {
          handleSessionExpiration();

          // getNotificationAlertPopUp(
          //   "Notification",
          //   "Session expired. Please sign in again",
          //   "error"
          // );
          // const keyToKeep = "visitor_uuid";
          // const valueToKeep = localStorage.getItem(keyToKeep); // Store the value

          // // clear local stoarge
          // localStorage.clear();

          // if (valueToKeep !== null) {
          //   localStorage.setItem(keyToKeep, valueToKeep); // Restore the key
          // }

          // // Redirect to sign-in page
          // setTimeout(() => {
          //   window.location = "/sign-in";
          // }, 3000);
        } else if (
          response?.data?.message === "p_token missing" ||
          response?.data?.message === "Invalid Token" ||
          response?.data?.message === "User Logged Out"
        ) {
          handleSessionExpiration();

          // show message, user has
          // getNotificationAlertPopUp(
          //   "Notification",
          //   "The p-token has expired",
          //   "error"
          // );

          // const keyToKeep = "visitor_uuid";
          // const valueToKeep = localStorage.getItem(keyToKeep); // Store the value

          // // clear local stoarge
          // localStorage.clear();

          // if (valueToKeep !== null) {
          //   localStorage.setItem(keyToKeep, valueToKeep); // Restore the key
          // }

          // // Redirect to landing page
          // timer = setTimeout(() => {
          //   window.location = "/";
          // }, 1000);
        } else if (response?.data?.status === "successful") {
          if (payloadObj?.offset === 0) {
            let topicHistoryList = response?.data?.result?.data;
            let obj = {
              persist_data: topicHistoryList,
              data: topicHistoryList,
              total_length: response?.data?.result?.total_user_sessions,
            };
            dispatch(setChattopicsHistory(obj));
            if (payloadObj?.offset === 0) {
              dispatch(setChatHistoryLoader(false));
            }
          } else {
            let oldList = payloadObj?.chatTopicsHistory?.data;
            let topicHistoryList = response?.data?.result?.data;

            // oldList = oldList?.map((old) => {
            //   topicHistoryList?.map((res) => {
            //     if (res?.name === old?.name) {
            //       old.content = [...old?.content, ...res?.content];
            //     }
            //   });
            //   return old;
            // });

            function mergeArrays(arr1, arr2) {
              let mergedArray = [];

              let map = new Map();

              // First, add all items from array1 to the map
              arr1.forEach((item) => {
                map.set(item.name, item);
              });

              // Next, iterate over array2
              arr2.forEach((item) => {
                if (map.has(item.name)) {
                  // If the name exists, merge the content arrays
                  map.get(item.name).content = map
                    .get(item.name)
                    .content.concat(item.content);
                } else {
                  // If the name doesn't exist, add the new item from array2
                  map.set(item.name, item);
                }
              });

              // Convert the map back into an array
              mergedArray = Array.from(map.values());

              return mergedArray;
            }

            let mergedArray = mergeArrays(oldList, topicHistoryList);

            let obj = {
              persist_data: mergedArray,
              data: mergedArray,
              total_length: response?.data?.result?.total_user_sessions,
            };
            dispatch(setChattopicsHistory(obj));
            if (payloadObj?.offset === 0) {
              dispatch(setChatHistoryLoader(false));
            }
          }
        } else {
          let obj = {
            persist_data: [],
            data: [],
            total_length: null,
          };
          dispatch(setChattopicsHistory(obj));
          if (payloadObj?.offset === 0) {
            dispatch(setChatHistoryLoader(false));
          }
        }
        return () => {
          clearTimeout(timer);
        };
      })
      .catch((error) => {
        if (payloadObj?.offset === 0) {
          dispatch(setChatHistoryLoader(false));
        }
        console.log("History API catch error", error);
      });
  };
};

// Get Specific Topic Chat History
export const getTopicChatsAPI = (payloadObj) => {
  let errorMessage;
  return async (dispatch) => {
    let body = {
      session_id: payloadObj?.session_id,
      offset: payloadObj?.offset,
      p_token: payloadObj?.p_token,
      instance_type: INSTANCE_TYPE,
    };

    if (payloadObj?.offset === 0) {
      dispatch(setTopicAnswerLoader(true));
    }
    let url = `${Config.config1.api_link}/chat-with-data/cwd-chat-history`;
    // True the flag
    if (payloadObj?.offset > 0) {
      // console.log("INSIDNE MEEME");
      // dispatch(setTopicAnswerOnScrollLoader(true));
    }
    axios
      .post(url, body)
      .then((response) => {
        if (response?.data?.status === "successful") {
          if (payloadObj?.offset === 0) {
            let topicChatHistory = response?.data?.result?.data;
            // Map and format anser and chart
            topicChatHistory = topicChatHistory?.map((d) => {
              if (d) {
                let newAns = d?.answer;
                let newChart = d?.highcharts_config_json;

                var text = newAns;
                var html = convertMarkdownToHTML(text);
                newAns = html;

                // Handle both formats:
                // - New format: native JSON array (already parsed by axios)
                // - Legacy format: JSON string that needs parsing
                if (newChart && typeof newChart === 'string' && newChart.length) {
                  try {
                    let updatedString = newChart.replace(/'/g, '"');
                    updatedString = updatedString.replace(/\bFalse\b/g, "false");
                    updatedString = updatedString.replace(/\bTrue\b/g, "true");
                    newChart = JSON.parse(updatedString);
                  } catch (e) {
                    newChart = null;
                  }
                }

                // Modifying here answer and chart
                d.answer = newAns;
                d.highcharts_config_json = newChart;
                if (d.artifact) {
                  d.chartComp = d.artifact;
                }

                // Strip [CHART:...] markers from displayed answer
                if (d.answer) {
                  d.answer = d.answer.replace(/\[CHART:[^\]]+\]/g, '');
                }

                // Reconstruct content_segments from [CHART:id] or [CHART:alias] markers in answer
                if (Array.isArray(newChart) && newChart.length > 0 && text) {
                  const chartMap = {};
                  newChart.forEach(c => {
                    if (c.id) chartMap[c.id] = c;
                    if (c._alias) chartMap[c._alias] = c;
                  });

                  // Split raw markdown on [CHART:chart-id] pattern
                  const parts = text.split(/\[CHART:([^\]]+)\]/);

                  const segments = [];
                  for (let i = 0; i < parts.length; i++) {
                    if (i % 2 === 0) {
                      const trimmed = parts[i].trim();
                      if (trimmed) {
                        segments.push({
                          type: "text",
                          content: trimmed,
                          html: convertMarkdownToHTML(trimmed),
                        });
                      }
                    } else {
                      const chartId = parts[i];
                      const chartConfig = chartMap[chartId];
                      if (chartConfig) {
                        segments.push({
                          type: "chart",
                          chartId: chartConfig.id,
                          chartTitle: chartConfig.description || chartConfig.config?.title?.text || "Chart",
                          charts: [chartConfig],
                        });
                      }
                    }
                  }

                  if (segments.some(s => s.type === 'chart')) {
                    d.content_segments = segments;
                  }
                }
              }
              return d;
            });

            // Preserve in-progress chats from other sessions so parallel streams continue
            const currentState = store.getState();
            const currentChatData = currentState.ChatWithData.chat_with_data_res.data || [];

            // In-progress chats from the CURRENT session (streaming/loader/no answer)
            const inProgressCurrentSessionChats = currentChatData.filter(chat => {
              const sameSession = chat.session_id === payloadObj.session_id ||
                                 chat.temp_session_id === payloadObj.session_id;
              if (!sameSession) return false;
              return !!(chat.loader || chat.is_streaming || chat.is_sse_streaming || !chat.answer);
            });

            // In-progress chats from OTHER sessions
            const inProgressOtherSessionsChats = currentChatData.filter(chat => {
              const differentSession = chat.session_id !== payloadObj.session_id &&
                                       chat.temp_session_id !== payloadObj.session_id;
              if (!differentSession) return false;
              return !!(chat.loader || chat.is_streaming || chat.is_sse_streaming || !chat.answer);
            });

            // Merge: other-session in-progress + loaded history + current-session in-progress
            const mergedData = [
              ...inProgressOtherSessionsChats,
              ...topicChatHistory,
              ...inProgressCurrentSessionChats,
            ];

            // Deduplicate by query_id
            const deduplicatedData = mergedData.reduce((acc, chat) => {
              const existingIndex = acc.findIndex((c) => c.query_id === chat.query_id);
              if (existingIndex === -1) {
                acc.push(chat);
              } else {
                const existing = acc[existingIndex];
                if (!!chat.answer && !existing.answer) {
                  acc[existingIndex] = chat;
                }
              }
              return acc;
            }, []);

            let obj = {
              persist_data: deduplicatedData,
              data: deduplicatedData,
              total_length: response?.data?.result?.total_chats,
            };
            dispatch(setChatWithDataResponse(obj));
            if (payloadObj?.offset === 0) {
              dispatch(setTopicAnswerLoader(false));
            }

            // Update Brand Here
            let chat =
              response?.data?.result?.data?.[
                response?.data?.result?.data?.length - 1
              ];
            let compBrandsList;
            if (chat?.comp_brand_list?.length) {
              compBrandsList = payloadObj?.brands?.filter(
                (d) => d?.brand_id === chat?.brand_list?.[0]?.brand_id
              );
            }

            let compBrands = {
              columns: [
                {
                  group: false,
                  name: chat?.brand_list?.[0]?.brand_id
                    ? chat?.brand_list?.[0]?.brand_id
                    : null,
                  type: "include",
                  brand_friendly_name: compBrandsList?.[0]?.brand_friendly_name, // Neeed these thinhg
                  brand_color: "#002342",
                  brand_group_name: false,
                  competitor: true,
                  competitorList: chat?.comp_brand_list,
                },
              ],
              attribute: "BrandID",
              type: "varchar",
            };

            let selectedBrand = chat?.comp_brand_list?.length
              ? compBrands
              : chat?.brandgroups?.length
              ? chat?.brandgroups
              : chat?.brand_list;

            dispatch(setBrandsInChatWithData(selectedBrand));

            // Update Duration here
            let selectedDuration = {
              from: chat?.start_date ? chat?.start_date : null,
              to: chat?.end_date ? chat?.end_date : null,
            };
            dispatch(setDurationInChatWithData(selectedDuration));
          } else {
            let oldData = payloadObj?.chatWithDataRes?.data;
            let topicChatHistory = response?.data?.result?.data;
            // Map and format anser and chart
            topicChatHistory = topicChatHistory?.map((d) => {
              if (d) {
                let newAns = d?.answer;
                let newChart = d?.highcharts_config_json;

                var text = newAns;
                var html = convertMarkdownToHTML(text);
                newAns = html;

                // Handle both formats:
                // - New format: native JSON array (already parsed by axios)
                // - Legacy format: JSON string that needs parsing
                if (newChart && typeof newChart === 'string' && newChart.length) {
                  try {
                    let updatedString = newChart.replace(/'/g, '"');
                    updatedString = updatedString.replace(/\bFalse\b/g, "false");
                    updatedString = updatedString.replace(/\bTrue\b/g, "true");
                    newChart = JSON.parse(updatedString);
                  } catch (e) {
                    newChart = null;
                  }
                }

                // Modifying here answer and chart
                d.answer = newAns;
                d.highcharts_config_json = newChart;

                // Strip [CHART:...] markers from displayed answer
                if (d.answer) {
                  d.answer = d.answer.replace(/\[CHART:[^\]]+\]/g, '');
                }

                // Reconstruct content_segments from [CHART:id] or [CHART:alias] markers in answer
                if (Array.isArray(newChart) && newChart.length > 0 && text) {
                  const chartMap = {};
                  newChart.forEach(c => {
                    if (c.id) chartMap[c.id] = c;
                    if (c._alias) chartMap[c._alias] = c;
                  });

                  const parts = text.split(/\[CHART:([^\]]+)\]/);

                  const segments = [];
                  for (let i = 0; i < parts.length; i++) {
                    if (i % 2 === 0) {
                      const trimmed = parts[i].trim();
                      if (trimmed) {
                        segments.push({
                          type: "text",
                          content: trimmed,
                          html: convertMarkdownToHTML(trimmed),
                        });
                      }
                    } else {
                      const chartId = parts[i];
                      const chartConfig = chartMap[chartId];
                      if (chartConfig) {
                        segments.push({
                          type: "chart",
                          chartId: chartConfig.id,
                          chartTitle: chartConfig.description || chartConfig.config?.title?.text || "Chart",
                          charts: [chartConfig],
                        });
                      }
                    }
                  }

                  if (segments.some(s => s.type === 'chart')) {
                    d.content_segments = segments;
                  }
                }
              }
              return d;
            });

            let mergedData = [...topicChatHistory, ...oldData];
            let obj = {
              persist_data: mergedData,
              data: mergedData,
              total_length: response?.data?.result?.total_chats,
            };
            dispatch(setChatWithDataResponse(obj));
            if (payloadObj?.offset === 0) {
              dispatch(setTopicAnswerLoader(false));
            }
          }
        } else if (response?.data?.error_code == 401) {
          handleSessionExpiration();

          // getNotificationAlertPopUp(
          //   "Notification",
          //   "Session expired. Please sign in again",
          //   "error"
          // );
          // const keyToKeep = "visitor_uuid";
          // const valueToKeep = localStorage.getItem(keyToKeep); // Store the value

          // // clear local stoarge
          // localStorage.clear();

          // if (valueToKeep !== null) {
          //   localStorage.setItem(keyToKeep, valueToKeep); // Restore the key
          // }

          // // Redirect to sign-in page
          // setTimeout(() => {
          //   window.location = "/sign-in";
          // }, 3000);
        } else {
          let obj = {
            persist_data: [],
            data: [],
            total_length: null,
          };
          dispatch(setChatWithDataResponse(obj));
          if (payloadObj?.offset === 0) {
            dispatch(setTopicAnswerLoader(false));
          }
        }
      })
      .catch((error) => {
        console.log("In catch getTopicChatsAPI error", error);
        if (payloadObj?.offset === 0) {
          dispatch(setTopicAnswerLoader(false));
        }

        // Dont Show Message Now
        // if (error.message !== "Request aborted") {
        //   callNotification(null, "error");
        // }
      });
  };
};

// Set Feedback API
export const setChatFeedbackAPI = (payloadObj) => {
  let errorMessage;
  return async (dispatch) => {
    let body = {
      session_id: payloadObj?.session_id,
      query_id: payloadObj?.query_id,
      feedback_flag: payloadObj?.feedback_flag,
      p_token: payloadObj?.p_token,
      visitor_id: payloadObj?.visitor_id,
      exit_review: payloadObj?.exit_review,
      is_custom_review: payloadObj?.is_custom_review,
      instance_type: INSTANCE_TYPE,
    };

    let url = `${Config.config1.api_link}/chat-with-data/cwd-chat-feedback`;
    axios
      .post(url, body)
      .then((response) => {
        if (response?.data?.status === "successful") {
          if (payloadObj?.feedback_flag === 2) {
            // getNotificationAlertPopUp("Notification", "Copied", "success");
          } else {
            // Update feedback state
            let chatWithData = payloadObj?.chatWithDataRes?.data?.map((d) => {
              if (d?.query_id === payloadObj?.query_id) {
                d.feedback_type = payloadObj?.feedback_flag;
              }
              return d;
            });

            let obj = {
              persist_data: chatWithData,
              data: chatWithData,
              total_length: null,
            };
            dispatch(setChatWithDataResponse(obj));

            if (
              payloadObj?.exit_review ||
              payloadObj?.is_custom_review ||
              payloadObj?.feedback_flag === 0
            ) {
              message.success({
                content: "Thank you for your feedback!",
                className: "custom-ant-message",
              });
            }
          }
        } else {
          response?.data?.message === "p_token missing" ||
          response?.data?.message === "Invalid Token" ||
          response?.data?.message === "User Logged Out"
            ? handleSessionExpiration()
            : getNotificationAlertPopUp(
                "Notification",
                response?.data?.result,
                "error"
              );
        }
      })
      .catch((error) => {
        console.log("cwd-chat-feedback API catch error", error);
        // Dont Show Message Now
        // if (error.message !== "Request aborted") {
        //   callNotification(null, "error");
        // }
      });
  };
};

// Get Starter Questions API
export const getStarterQuestionsAPI = (payloadObj) => {
  let errorMessage;
  return async (dispatch) => {
    let body = {
      p_token: payloadObj?.p_token,
      visitor_id: payloadObj?.p_token ? null : payloadObj?.visitor_id,
      instance_type: INSTANCE_TYPE,
    };

    dispatch(setStarterQuestionsLoader(true));
    let url = `${Config.config1.api_link}/chat-with-data/starter-questions`;
    axios
      .post(url, body)
      .then((response) => {
        if (response?.data?.status === "successful") {
          dispatch(setStarterQuestions(response?.data?.result));
          dispatch(setStarterQuestionsLoader(false));
        } else {
          dispatch(setStarterQuestionsLoader(false));
          response?.data?.message === "p_token missing" ||
          response?.data?.message === "Invalid Token" ||
          response?.data?.message === "User Logged Out"
            ? handleSessionExpiration()
            : getNotificationAlertPopUp(
                "Notification",
                response?.data?.result,
                "error"
              );
        }
      })
      .catch((error) => {
        dispatch(setStarterQuestionsLoader(false));
        console.log("Started Questions API catch error", error);
        // Dont Show Message Now
        // if (error.message !== "Request aborted") {
        //   callNotification(null, "error");
        // }
      });
  };
};

// Get Starter Questions API
export const getNewChatNameAPI = (payloadObj) => {
  let errorMessage;
  return async (dispatch) => {
    let body = {
      session_id: payloadObj?.session_id,
      question: payloadObj?.question,
      answer: payloadObj?.answer,
      p_token: payloadObj?.p_token,
      instance_type: INSTANCE_TYPE,
    };

    let url = `${Config.config1.api_link}/chat-with-data/cwd-get-session-name`;
    axios
      .post(url, body)
      .then((response) => {
        if (response?.data?.status === "successful") {
          let newName = response?.data?.result?.[0];
          let updatedHistoryList = payloadObj?.chatTopicsHistory?.data;
          if (updatedHistoryList?.length) {
            updatedHistoryList[0].content[0] = newName;
          } else {
            let newChatNameObj = [
              {
                name: "Today",
                content: [newName],
              },
            ];
            updatedHistoryList = newChatNameObj;
          }

          // Update the new chat name
          let obj = {
            ...payloadObj?.chatTopicsHistory,
            persist_data: updatedHistoryList,
            data: updatedHistoryList,
          };
          dispatch(setChattopicsHistory(obj));

          // To Show Selected session name or selected chat
          dispatch(setSelectedChatData(newName));
        } else {
          // getNotificationAlertPopUp(
          //   "Notification",
          //   response?.data?.result,
          //   "error"
          // );
        }
      })
      .catch((error) => {
        console.log("In getNewChatNameAPI Catch Error", error);
        // Dont Show Message Now
        // if (error.message !== "Request aborted") {
        //   callNotification(null, "error");
        // }
      });
  };
};

// Get Trending Suggestions Questions API
export const getTrendingSuggestionsAPI = (payloadObj) => {
  let errorMessage;
  return async (dispatch) => {
    let body = {
      p_token: payloadObj?.p_token,
      visitor_id: payloadObj?.p_token ? null : payloadObj?.visitor_id,
      instance_type: INSTANCE_TYPE,
    };

    dispatch(setTrendingSuggestionsLoader(true));
    let url = `${Config.config1.api_link}/chat-with-data/trending-questions`;
    axios
      .post(url, body)
      .then((response) => {
        if (response?.data?.status === "successful") {
          dispatch(setTrendingSuggestionsList(response?.data?.result));
          dispatch(setTrendingSuggestionsLoader(false));
        } else {
          dispatch(setTrendingSuggestionsLoader(false));
          response?.data?.message === "p_token missing" ||
          response?.data?.message === "Invalid Token" ||
          response?.data?.message === "User Logged Out"
            ? handleSessionExpiration()
            : getNotificationAlertPopUp(
                "Notification",
                response?.data?.result,
                "error"
              );
        }
      })
      .catch((error) => {
        dispatch(setTrendingSuggestionsLoader(false));
        console.log("Started Questions API catch error", error);
        // Dont Show Message Now
        // if (error.message !== "Request aborted") {
        //   callNotification(null, "error");
        // }
      });
  };
};

// Get Visitor Id Against Ip Address API
export const getVisitorIdAPI = (obj) => {
  let errorMessage;
  return async (dispatch) => {
    let body = {
      ip_address: obj?.ip_address,
      country_code: obj?.country_code,
      country: obj?.country_name,
      // p_token: payloadObj?.p_token,
      visitor_uuid: obj?.visitor_uuid,
      instance_type: INSTANCE_TYPE,
    };

    dispatch(setGetVisitorIdLoader(true));
    let url = `${Config.config1.api_link}/auth/get-visitor-id`;
    const creditCountExists = localStorage.getItem("credit_count");
    axios
      .post(url, body)
      .then((response) => {
        if (response?.data?.status === "successful") {
          localStorage.setItem("visitor_id", response?.data?.visitor_id);
          if (!creditCountExists) {
            localStorage.setItem("credit_count", response?.data?.credit_count);
          }

          localStorage.setItem(
            "is_subscription_active",
            response?.data?.is_subscription_active
          );

          dispatch(setGetVisitorIdLoader(false));
        } else {
          response?.data?.message === "p_token missing" ||
          response?.data?.message === "Invalid Token" ||
          response?.data?.message === "User Logged Out"
            ? handleSessionExpiration()
            : getNotificationAlertPopUp(
                "Notification",
                response?.data?.result,
                "error"
              );
          dispatch(setGetVisitorIdLoader(false));
        }
      })
      .catch((error) => {
        console.log("In getVisitorIdAPI Catch Error", error);
        dispatch(setGetVisitorIdLoader(false));
      });
  };
};

// Set Sign Up API
export const setSignUpAPI = (payloadObj) => {
  let errorMessage;
  return async (dispatch) => {
    let body = {
      email: payloadObj?.email,
      password: payloadObj?.password,
      // captcha_token: payloadObj?.captcha_token,
      first_name: payloadObj?.firstName,
      last_name: payloadObj?.lastName,
      country_code: payloadObj?.country_code,
      phone_number: payloadObj?.phone_number,
      // query_id: payloadObj?.query_id,
      instance_type: INSTANCE_TYPE,
    };

    let url = `${Config.config1.api_link}/auth/sign-up`;
    dispatch(setSignUpLoader(true));
    axios
      .post(url, body)
      .then((response) => {
        if (response?.data?.status === "successful") {
          if (response?.data?.signup_failed) {
            dispatch(
              setSignUpFailedFlag({
                flag: true,
                message: response?.data?.message,
              })
            );
            dispatch(setSignUpLoader(false));
          } else {
            if (response?.data?.message) {
              getNotificationAlertPopUp(
                "Notification",
                response?.data?.message,
                "success"
              );
            }
            localStorage.setItem(
              "returning_user",
              response?.data?.returning_user
            );

            // Open OTP Page
            dispatch(setOtpStatusFlag(true));
            dispatch(setSignUpLoader(false));
            dispatch(setSignInThroughFlag(response?.data?.logged_in_thru));
          }
        } else {
          if (response?.data?.message) {
            response?.data?.message === "p_token missing" ||
            response?.data?.message === "Invalid Token" ||
            response?.data?.message === "User Logged Out"
              ? handleSessionExpiration()
              : getNotificationAlertPopUp(
                  "Notification",
                  response?.data?.message,
                  "error"
                );
          }

          dispatch(setOtpStatusFlag(false));
          dispatch(setSignUpLoader(false));
          dispatch(setSignInThroughFlag(response?.data?.logged_in_thru));
        }
      })
      .catch((error) => {
        dispatch(setOtpStatusFlag(false));
        dispatch(setSignUpLoader(false));

        console.log("auth/sign-up API catch error", error);
      });
  };
};

// Set Sign Up API
export const setSignInAPI = (payloadObj) => {
  const SIGN_IN_METHOD = "locobuzz_credentials";
  let errorMessage;
  return async (dispatch) => {
    let body = {
      username: payloadObj?.username,
      password: payloadObj?.password,
      // query_id: payloadObj?.query_id,
      instance_type: INSTANCE_TYPE,
    };

    let url = `${Config.config1.api_link}/auth/locobuzz`;
    dispatch(setSignUpLoader(true));
    axios
      .post(url, body)
      .then((response) => {
        let timer = null;
        if (response?.data?.status === "successful") {
          const userId = response.data.user_id || payloadObj?.username;

          identifyUser(userId, {
            username: payloadObj?.username,
            credit_count: response.data.credit_count,
            is_subscription_active: response.data.is_subscription_active,
          });
          trackEvent("FR_USER_SIGNED_IN", {
            status: "success",
            sign_in_method: SIGN_IN_METHOD,
            has_query_id: !!payloadObj?.query_id,
            has_share_id: !!payloadObj?.share_id,
          });

          getNotificationAlertPopUp(
            "Notification",
            response?.data?.message,
            "success"
          );

          // Store user id
          localStorage.setItem("p_token", response?.data?.p_token);
          localStorage.setItem("credit_count", response?.data?.credit_count);
          localStorage.setItem(
            "is_subscription_active",
            response?.data?.is_subscription_active
          );
          localStorage.removeItem("visitor_id");
          if (payloadObj?.query_id) {
            localStorage.setItem("show_visited_session", "true");
          }

          timer = setTimeout(() => {
            if (payloadObj?.query_id) {
              window.location = `/chat-with-data?query_id=${payloadObj?.query_id}`;
            } else if (payloadObj?.share_id) {
              window.location = `/share/id/${payloadObj?.share_id}`;
            } else {
              window.location = "/chat-with-data";
            }
          }, 1000);
          dispatch(setSignUpLoader(false));
        } else {
          trackEvent("FR_USER_SIGNED_IN", {
            status: "failed",
            sign_in_method: SIGN_IN_METHOD,
            reason: response?.data?.message,
          });
          response?.data?.message === "p_token missing" ||
          response?.data?.message === "Invalid Token" ||
          response?.data?.message === "User Logged Out"
            ? handleSessionExpiration()
            : getNotificationAlertPopUp(
                "Notification",
                response?.data?.message,
                "error"
              );
          dispatch(setSignUpLoader(false));
        }
        return () => {
          clearTimeout(timer);
        };
      })
      .catch((error) => {
        trackEvent("FR_USER_SIGNED_IN", {
          status: "failed",
          sign_in_method: SIGN_IN_METHOD,
          reason: error.message,
          http_status: error.response?.status,
        });

        dispatch(setSignUpLoader(false));
        console.log("auth/sign-in API catch error", error);
      });
  };
};

// Set Auth Validate or OTP validate API
export const setAuthValidateAPI = (payloadObj) => {
  let errorMessage;

  return async (dispatch) => {
    let body = {
      email: payloadObj?.email,
      otp: payloadObj?.otp,
      visitor_id: payloadObj?.visitor_id,
      ref_id: payloadObj?.ref_id,
      // query_id: payloadObj?.query_id,
      instance_type: INSTANCE_TYPE,
    };

    let url = `${Config.config1.api_link}/auth/validate-otp`;
    dispatch(setOtpValidateLoader(true));
    axios
      .post(url, body)
      .then((response) => {
        let timer = null;
        if (response?.data?.status === "successful") {
          trackEvent("FR_USER_SIGNED_UP", {
            status: "success",
            method: "email_otp",
            visitor_id: payloadObj.visitor_id,
          });
          getNotificationAlertPopUp(
            "Notification",
            response?.data?.message,
            "success"
          );

          // Store user id
          localStorage.setItem("p_token", response?.data?.p_token);
          localStorage.setItem("credit_count", response?.data?.credit_count);
          localStorage.setItem(
            "is_subscription_active",
            response?.data?.is_subscription_active
          );
          localStorage.removeItem("visitor_id");

          // Remove Ref id
          if (payloadObj?.ref_id) {
            localStorage.removeItem("ref_id");
          }
          if (payloadObj?.query_id) {
            localStorage.setItem("show_visited_session", "true");
          }
          dispatch(setOtpValidateLoader(false));

          if (payloadObj?.sign_in_flow) {
            // Sign In Flow
            timer = setTimeout(() => {
              if (payloadObj?.query_id) {
                window.location = `/chat-with-data?query_id=${payloadObj?.query_id}`;
              } else if (payloadObj?.share_id) {
                window.location = `/share/id/${payloadObj?.share_id}`;
              } else {
                window.location = "/chat-with-data";
              }
            }, 1000);

            timer = setTimeout(() => {
              dispatch(setSignInThroughFlag(null));
            }, 2000);
          } else {
            // Sign Up Flow
            localStorage.setItem("create_password_flow", true);
            timer = setTimeout(() => {
              window.location = payloadObj?.query_id
                ? `/create-password?query_id=${payloadObj?.query_id}`
                : payloadObj?.share_id
                ? `/create-password?share_id=${payloadObj?.share_id}`
                : "/create-password";
            }, 1000);
          }
        } else if (response?.data?.status === "error") {
          trackEvent("FR_SIGN_UP_FAILED", {
            status: "failed",
            method: "email_otp",
            reason: response?.data?.message,
            visitor_id: payloadObj.visitor_id,
          });
          if (
            response?.data?.message ==
            "Too many failed attempts. Please request a new OTP."
          ) {
            response?.data?.message === "p_token missing" ||
            response?.data?.message === "Invalid Token" ||
            response?.data?.message === "User Logged Out"
              ? handleSessionExpiration()
              : getNotificationAlertPopUp(
                  "Notification",
                  response?.data?.message,
                  "error"
                );

            dispatch(setOtpStatusFlag(false));
          } else {
            response?.data?.message === "p_token missing" ||
            response?.data?.message === "Invalid Token" ||
            response?.data?.message === "User Logged Out"
              ? handleSessionExpiration()
              : getNotificationAlertPopUp(
                  "Notification",
                  response?.data?.message,
                  "error"
                );
          }
          dispatch(setOtpValidateLoader(false));
        } else {
          trackEvent("FR_SIGN_UP_FAILED", {
            status: "failed",
            method: "email_otp",
            reason: response?.data?.message,
            visitor_id: payloadObj.visitor_id,
          });
          response?.data?.message === "p_token missing" ||
          response?.data?.message === "Invalid Token" ||
          response?.data?.message === "User Logged Out"
            ? handleSessionExpiration()
            : getNotificationAlertPopUp(
                "Notification",
                response?.data?.message,
                "error"
              );
          dispatch(setOtpValidateLoader(false));
        }
        return () => {
          clearTimeout(timer);
        };
      })
      .catch((error) => {
        trackEvent("FR_SIGN_UP_FAILED", {
          status: "failed",
          method: "email_otp",
          reason: error.message,
          http_status: error.response?.status,
          visitor_id: payloadObj.visitor_id,
        });
        dispatch(setOtpValidateLoader(false));
        console.log("auth/validate API catch error", error);
      });
  };
};

// get google Auth API
export const getGoogleAuthAPI = (payloadObj) => {
  let errorMessage;
  const OAUTH_PROVIDER = payloadObj?.login_type;
  return async (dispatch) => {
    let body = {
      login_type: payloadObj?.login_type,
      ref_id: payloadObj?.ref_id,
      // query_id: payloadObj?.query_id,
      instance_type: INSTANCE_TYPE,
    };

    let url = `${Config.config1.api_link}/auth/oauth`;
    dispatch(setAuthLoader(true));
    trackEvent("FR_OAUTH_FLOW_INITIATED", {
      provider: OAUTH_PROVIDER,
      has_ref_id: !!payloadObj?.ref_id,
      has_share_id: !!payloadObj?.share_id,
    });
    axios
      .post(url, body)
      .then((response) => {
        let timer = null;
        if (response?.data?.authorization_url) {
          trackEvent("FR_OAUTH_REDIRECT_URL_RECEIVED", {
            provider: OAUTH_PROVIDER,
            status: "success",
          });
          try {
            if (payloadObj?.share_id) {
              localStorage.setItem("share_id", payloadObj?.share_id);
            }
            window.location = response?.data?.authorization_url;
          } catch (error) {
            localStorage.removeItem("share_id", payloadObj?.share_id);
          }
          timer = setTimeout(() => {
            dispatch(setAuthLoader(false));
          }, 10000);
          if (payloadObj?.query_id) {
            localStorage.setItem("show_visited_session", "true");
          }
        } else {
          trackEvent("FR_OAUTH_REDIRECT_URL_RECEIVED", {
            provider: OAUTH_PROVIDER,
            status: "failed",
            reason: "API did not return an authorization_url",
          });

          dispatch(setAuthLoader(false));
          getNotificationAlertPopUp("Notification", "OAuth Failed", "error");
        }
        return () => {
          clearTimeout(timer);
        };
      })
      .catch((error) => {
        trackEvent("FR_OAUTH_REDIRECT_URL_RECEIVED", {
          provider: OAUTH_PROVIDER,
          status: "failed",
          reason: error.message,
          http_status: error.response?.status,
        });
        dispatch(setAuthLoader(false));
        console.log("auth/ API catch error", error);
      });
  };
};

// Set Auth Validate or OTP validate API
export const setSendReferenceAPI = (payloadObj) => {
  let errorMessage;

  return async (dispatch) => {
    let body = {
      emails: payloadObj?.emails,
      p_token: payloadObj?.p_token,
      instance_type: INSTANCE_TYPE,
    };

    let url = `${Config.config1.api_link}/auth/send-reference`;
    axios
      .post(url, body)
      .then((response) => {
        if (response?.data?.status === "successful") {
          getNotificationAlertPopUp(
            "Notification",
            response?.data?.message,
            "success"
          );

          // Call Get Profile
          let userObj = {
            p_token: payloadObj?.p_token ? payloadObj?.p_token : null,
          };
          dispatch(getUserProfileDetailsAPI({ ...userObj, force: true }));
        } else {
          response?.data?.message === "p_token missing" ||
          response?.data?.message === "Invalid Token" ||
          response?.data?.message === "User Logged Out"
            ? handleSessionExpiration()
            : getNotificationAlertPopUp(
                "Notification",
                response?.data?.message,
                "error"
              );
        }
      })
      .catch((error) => {
        console.log("send-reference API catch error", error);
      });
  };
};

// Get User Refer Credits Notification API
export const getUserReferCreditsNotificationAPI = (payloadObj) => {
  let errorMessage;

  return async (dispatch) => {
    let body = {
      p_token: payloadObj?.p_token,
      instance_type: INSTANCE_TYPE,
    };

    let url = `${Config.config1.api_link}/auth/get-user-ref-credits`;
    axios
      .post(url, body)
      .then((response) => {
        if (response?.data?.status === "successful") {
          getNotificationAlertPopUp(
            "Notification",
            response?.data?.message,
            "success"
          );
        } else {
          response?.data?.message === "p_token missing" ||
          response?.data?.message === "Invalid Token" ||
          response?.data?.message === "User Logged Out"
            ? handleSessionExpiration()
            : getNotificationAlertPopUp(
                "Notification",
                response?.data?.message,
                "error"
              );
        }
      })
      .catch((error) => {
        console.log("auth/get-user-ref-credits API catch error", error);
      });
  };
};

// Get User Credits Count API
export const getUserCreditsCountAPI = (payloadObj) => {
  let errorMessage;

  return async (dispatch) => {
    let body = {
      visitor_id: payloadObj?.visitor_id,
      p_token: payloadObj?.p_token,
      instance_type: INSTANCE_TYPE,
    };

    let url = `${Config.config1.api_link}/auth/get-credits`;
    dispatch(setCreditsCountLoader(true));
    axios
      .post(url, body)
      .then((response) => {
        if (response?.data?.status === "successful") {
          // Store credit_count
          localStorage.setItem("credit_count", response?.data?.credit_count);
          localStorage.setItem(
            "is_subscription_active",
            response?.data?.is_subscription_active
          );
          localStorage.setItem(
            "is_locobuzz_user",
            response?.data?.is_locobuzz_user
          );
          dispatch(setCreditsCountLoader(false));

          // if flag, show pop or show message
          if (response?.data?.is_new_user) {
            getNotificationAlertPopUp(
              "Notification",
              response?.data?.message,
              "success"
            );
          }
        } else {
          response?.data?.message === "p_token missing" ||
          response?.data?.message === "Invalid Token" ||
          response?.data?.message === "User Logged Out" ||
          response?.data?.message?.toLowerCase()?.includes("user not found")
            ? handleSessionExpiration()
            : getNotificationAlertPopUp(
                "Notification",
                response?.data?.message,
                "error"
              );
          dispatch(setCreditsCountLoader(false));
        }
      })
      .catch((error) => {
        dispatch(setCreditsCountLoader(false));
        console.log("auth/get-credits API catch error", error);
      });
  };
};

// Get User Refer Credits Notification API
export const setLogoutUserAPI = (payloadObj) => {
  let errorMessage;

  return async (dispatch) => {
    let body = {
      p_token: payloadObj?.p_token,
      instance_type: INSTANCE_TYPE,
    };

    let url = `${Config.config1.api_link}/auth/logout`;
    axios
      .post(url, body)
      .then((response) => {
        if (response?.data?.status === "successful") {
          const keyToKeep = "visitor_uuid";
          const valueToKeep = localStorage.getItem(keyToKeep); // Store the value

          // clear local stoarge
          localStorage.clear();

          if (valueToKeep !== null) {
            localStorage.setItem(keyToKeep, valueToKeep); // Restore the key
          }
        } else {
          response?.data?.message === "p_token missing" ||
          response?.data?.message === "Invalid Token" ||
          response?.data?.message === "User Logged Out"
            ? handleSessionExpiration()
            : getNotificationAlertPopUp(
                "Notification",
                response?.data?.message,
                "error"
              );
        }
      })
      .catch((error) => {
        console.log("auth/get-user-ref-credits API catch error", error);
      });
  };
};

// Get User Profile Details API
export const getUserProfileDetailsAPI = (payloadObj = {}) => {
  return async (dispatch, getState) => {
    const state = getState();
    const hasProfile = !!state?.ChatWithData?.user_profile_details;
    const now = Date.now();
    const force = payloadObj?.force;

    // Throttle if we already have profile and it's fresh
    if (!force && hasProfile && now - lastProfileFetchTime < PROFILE_FETCH_TTL) {
      return; // skip network call
    }

    // If a request already in-flight, reuse it
    if (!force && profileFetchInFlight) {
      return profileFetchInFlight;
    }

    const body = { p_token: payloadObj?.p_token, instance_type: INSTANCE_TYPE };
    const url = `${Config.config1.api_link}/auth/get-profile`;

    const request = axios
      .post(url, body)
      .then((response) => {
        if (response?.data?.status === "successful") {
          const profileDetails = response?.data?.result;
            const countryCode = profileDetails?.profile_info?.region;
            const matchedCountry = updatedCountriesList.find(
              (country) => country.code === countryCode
            );
            if (matchedCountry) {
              localStorage.setItem("selectedCountry", matchedCountry.name);
              localStorage.setItem("selectedCountryCode", matchedCountry.code);
            }
            dispatch(setUserProfileDetails(profileDetails));
            dispatch(setPersona(profileDetails?.profile_info?.persisted_persona));
            lastProfileFetchTime = Date.now();
        } else if (response?.data?.error_code == 401) {
          handleSessionExpiration();
        } else {
          response?.data?.message === "p_token missing" ||
          response?.data?.message === "Invalid Token" ||
          response?.data?.message === "User Logged Out" ||
          response?.data?.message?.toLowerCase()?.includes("user not found")
            ? handleSessionExpiration()
            : getNotificationAlertPopUp(
                "Notification",
                response?.data?.message,
                "error"
              );
        }
      })
      .catch((error) => {
        console.log("auth/get-profile API catch error", error);
      })
      .finally(() => {
        profileFetchInFlight = null;
      });

    profileFetchInFlight = request;
    return request;
  };
};

// Update User Profile Details API
export const updateUserProfileDetailsAPI = (payloadObj, isMobNumUpadated) => {
  let errorMessage;

  return async (dispatch) => {
    let body = {
      p_token: payloadObj?.p_token,
      first_name: payloadObj?.first_name,
      last_name: payloadObj?.last_name,
      country_code: payloadObj?.country_code,
      mobile_number: payloadObj?.mobile_number,
      profile_pic: payloadObj?.profile_pic,
      gender: payloadObj?.gender,
      dob: payloadObj?.dob,
      region: payloadObj?.region,
      instance_type: INSTANCE_TYPE,
    };

    dispatch(setUserProfileSaveLoader(true));
    let url = `${Config.config1.api_link}/auth/set-profile`;
    axios
      .post(url, body)
      .then((response) => {
        if (response?.data?.status === "successful") {
          if (!isMobNumUpadated) {
            getNotificationAlertPopUp(
              "Notification",
              response?.data?.message,
              "success"
            );
          }

          // To get updated data using get-profile API
          let obj = {
            p_token: payloadObj?.p_token,
          };
          dispatch(getUserProfileDetailsAPI({ ...obj, force: true }));

          dispatch(setUserProfileSaveLoader(false));
          dispatch(setUserProfileModalFlag(false));
        } else if (response?.data?.error_code == 401) {
          handleSessionExpiration();
          // getNotificationAlertPopUp(
          //   "Notification",
          //   "Session expired. Please sign in again",
          //   "error"
          // );
          // const keyToKeep = "visitor_uuid";
          // const valueToKeep = localStorage.getItem(keyToKeep); // Store the value

          // // clear local stoarge
          // localStorage.clear();

          // if (valueToKeep !== null) {
          //   localStorage.setItem(keyToKeep, valueToKeep); // Restore the key
          // }

          // // Redirect to sign-in page
          // setTimeout(() => {
          //   window.location = "/sign-in";
          // }, 3000);
        } else {
          response?.data?.message === "p_token missing" ||
          response?.data?.message === "Invalid Token" ||
          response?.data?.message === "User Logged Out"
            ? handleSessionExpiration()
            : getNotificationAlertPopUp(
                "Notification",
                response?.data?.message,
                "error"
              );
          dispatch(setUserProfileSaveLoader(false));
          dispatch(setUserProfileModalFlag(false));
        }
      })
      .catch((error) => {
        console.error("API Error - auth/set-profile:", error);
        dispatch(setUserProfileSaveLoader(false));
        dispatch(setUserProfileModalFlag(false));
      });
  };
};

// Set Payment Create Order API
export const setPaymentCreateOrderAPI = (payloadObj) => {
  let errorMessage;

  return async (dispatch) => {
    let body = {
      p_token: payloadObj?.p_token,
      amount: payloadObj?.amount,
      currency: payloadObj?.currency,
      notes: payloadObj?.notes ? payloadObj?.notes : {},
      instance_type: INSTANCE_TYPE,
    };

    dispatch(setPaymentProcessLoader(true));
    let url = `${Config.config1.api_link}/payments/create-order`;
    axios
      .post(url, body)
      .then((response) => {
        // console.log("payments/create-order response", response);
        if (response?.data?.status === "success") {
          // console.log("response", response);
          let order_id = response?.data?.order?.id;
          // Call Next Step Here
          let updated_amount = payloadObj?.amount;
          let name = payloadObj?.full_name;
          let email = payloadObj?.email;
          let contact = payloadObj?.mobile_number;

          // Add key in env file
          var options = {
            key: "rzp_test_qUBbaDZsfBeinO", // Enter the Key ID generated from the Dashboard
            amount: updated_amount, // Amount is in currency subunits. Default currency is INR. Hence, 50000 refers to 50000 paise
            currency: "USD",
            name: "Locobuzz Solution Pvt Ltd", //your business name
            description: "Test Transaction",
            image: "https://example.com/your_logo",
            order_id: order_id, //This is a sample Order ID. Pass the `id` obtained in the response of Step 1
            handler: function (response) {
              console.log("Payment Success !", response);
              // alert(response.razorpay_payment_id);
              // alert(response.razorpay_order_id);
              // alert(response.razorpay_signature);

              if (response?.razorpay_payment_id) {
                let verifyPaymentObj = {
                  p_token: payloadObj?.p_token,
                  amount: updated_amount,
                  currency: payloadObj?.currency,
                  payment_id: response?.razorpay_payment_id,
                };
                dispatch(setPaymentVerifyOrderAPI(verifyPaymentObj));
              }
            },
            prefill: {
              name: name,
              email: email,
              contact: contact,
            },
            notes: {
              address: "Locobuzz Solution Corporate Office",
            },
            theme: {
              color: "#3399cc",
            },
          };

          var rzp1 = new window.Razorpay(options);
          rzp1.on("payment.failed", function (response) {
            console.log("Payment Failed !", response);
            // alert(response.error.code);
            // alert(response.error.description);
            // alert(response.error.source);
            // alert(response.error.step);
            // alert(response.error.reason);
            // alert(response.error.metadata.order_id);
            // alert(response.error.metadata.payment_id);
          });

          // Main Start
          rzp1.open();
        } else {
          response?.data?.message === "p_token missing" ||
          response?.data?.message === "Invalid Token" ||
          response?.data?.message === "User Logged Out"
            ? handleSessionExpiration()
            : getNotificationAlertPopUp(
                "Notification",
                response?.data?.message,
                "error"
              );
          dispatch(setPaymentProcessLoader(false));
        }
      })
      .catch((error) => {
        dispatch(setPaymentProcessLoader(false));

        console.log("payments/create-order API catch error", error);
      });
  };
};

// Set Payment Verify Order API
export const setPaymentVerifyOrderAPI = (payloadObj) => {
  let errorMessage;

  return async (dispatch) => {
    let body = {
      p_token: payloadObj?.p_token,
      amount: payloadObj?.amount,
      currency: payloadObj?.currency,
      payment_id: payloadObj?.payment_id,
      instance_type: INSTANCE_TYPE,
    };

    let url = `${Config.config1.api_link}/payments/verify-order`;
    axios
      .post(url, body)
      .then((response) => {
        let timer = null;
        if (response?.data?.status === "success") {
          dispatch(setPaymentProcessLoader(false));
          dispatch(getUserProfileDetailsAPI({ ...payloadObj, force: true }));
          getNotificationAlertPopUp(
            "Notification",
            "Payment Success",
            "success"
          );

          // Redirect to chat page, After getting payment id
          timer = setTimeout(() => {
            window.location = "/chat-with-data";
          }, 1000);
        } else {
          response?.data?.message === "p_token missing" ||
          response?.data?.message === "Invalid Token" ||
          response?.data?.message === "User Logged Out"
            ? handleSessionExpiration()
            : getNotificationAlertPopUp(
                "Notification",
                response?.data?.message,
                "error"
              );
          dispatch(setPaymentProcessLoader(false));
        }
        return () => {
          clearTimeout(timer);
        };
      })
      .catch((error) => {
        dispatch(setPaymentProcessLoader(false));

        console.log("payments/verify-order API catch error", error);
      });
  };
};

// Get Follow Up Questions API
// DISABLED: Follow-up questions now come from SSE stream (follow_up_chunk events)
// This API is kept for backward compatibility but will skip if stream questions exist
export const getFollowUpQuestionsListAPI = (payloadObj) => {
  return async (dispatch) => {
    try {
      // Check if a follow-up request for this query_id is already active
      if (activeFollowUpQueries.has(payloadObj?.query_id)) {
        return;
      }

      // Check if follow-up questions were already received from the SSE stream
      // If so, skip this API call entirely - we only use stream questions now
      const currentState = store.getState();
      const currentChatData = currentState.ChatWithData.chat_with_data_res.data;
      const existingChat = currentChatData?.find(d => d?.query_id === payloadObj?.query_id);
      
      if (existingChat?.follow_up_questions_list?.length > 0) {
        // Follow-up questions from stream exist, skip API call
        dispatch(setFollowUpQuestionsLoader(false));
        return;
      }

      // No stream questions received - just set loader to false
      // We no longer call the API or use hardcoded questions
      dispatch(setFollowUpQuestionsLoader(false));
      
    } catch (error) {
      dispatch(setFollowUpQuestionsLoader(false));
    } finally {
      // Remove this query_id from active set when done
      if (payloadObj?.query_id) {
        activeFollowUpQueries.delete(payloadObj?.query_id);
      }
    }
  };
};

// Set Search Chat API
export const setSearchChatHistoryAPI = (payloadObj) => {
  let errorMessage;
  return async (dispatch) => {
    let body = {
      search_text: payloadObj?.search_text,
      p_token: payloadObj?.p_token,
      instance_type: INSTANCE_TYPE,
    };

    dispatch(setChatHistoryLoader(true));
    let url = `${Config.config1.api_link}/chat-with-data/cwd-search-session`;
    axios
      .post(url, body)
      .then((response) => {
        if (response?.data?.status === "successful") {
          dispatch(setChatHistoryLoader(false));
          let topicHistoryList =
            response?.data?.result === "No results found."
              ? response?.data?.result
              : response?.data?.result?.data;
          let obj = {
            persist_data: topicHistoryList,
            data: topicHistoryList,
            total_length: response?.data?.result?.total_user_sessions,
          };
          dispatch(setChattopicsHistory(obj));
        } else {
          dispatch(setChatHistoryLoader(false));
          response?.data?.message === "p_token missing" ||
          response?.data?.message === "Invalid Token" ||
          response?.data?.message === "User Logged Out"
            ? handleSessionExpiration()
            : getNotificationAlertPopUp(
                "Notification",
                response?.data?.message,
                "error"
              );
        }
      })
      .catch((error) => {
        dispatch(setChatHistoryLoader(false));
        console.log("cwd-search-session API catch error", error);
      });
  };
};

// Set Delete Chat API
export const setDeleteChatHistoryAPI = (payloadObj) => {
  let errorMessage;
  return async (dispatch) => {
    // Check if session_id or temp_session_id is valid
    if (!payloadObj?.session_id && !payloadObj?.clear_all) {
      // If no session_id, this might be a temp session that hasn't been saved yet
      // Handle deletion from local state only
      if (payloadObj?.temp_session_id) {
        // Delete from local state only (no API call needed for unsaved sessions)
        getNotificationAlertPopUp(
          "Notification",
          "Chat deleted successfully",
          "success"
        );

        // Reset Chat Response for this temp session
        const currentState = store.getState();
        const currentChatData = currentState.ChatWithData.chat_with_data_res.data;
        
        // Filter out chats with this temp_session_id
        const filteredChats = currentChatData.filter(
          (chat) => chat.temp_session_id !== payloadObj.temp_session_id
        );
        
        let obj = {
          persist_data: filteredChats,
          data: filteredChats,
          total_length: null,
        };
        dispatch(setChatWithDataResponse(obj));
        
        // Reset selected chat data if it was the deleted one
        const selectedChatData = currentState.ChatWithData.selected_chat_data;
        if (selectedChatData?.temp_session_id === payloadObj.temp_session_id) {
          dispatch(setSelectedChatData(null));
        }

        // Delete from chat history
        let updatedChatList = payloadObj?.chatTopicsHistory?.data?.map(
          (chat) => {
            chat.content = chat?.content?.filter(
              (d) => d?.temp_session_id !== payloadObj?.temp_session_id
            );
            return chat;
          }
        );
        
        // Remove empty chat list title from sidebar
        if (updatedChatList?.[0]?.content?.length === 0) {
          updatedChatList?.shift();
        }

        let chat_obj = {
          persist_data: updatedChatList,
          data: updatedChatList,
          total_length: payloadObj?.total_length ? payloadObj?.total_length - 1 : null,
        };
        dispatch(setChattopicsHistory(chat_obj));
        return;
      }
      
      getNotificationAlertPopUp(
        "Notification",
        "Unable to delete chat. Please try again.",
        "error"
      );
      return;
    }

    let body = {
      p_token: payloadObj?.p_token,
      session_id: payloadObj?.session_id,
      clear_all: payloadObj?.clear_all ? payloadObj?.clear_all : false,
      instance_type: INSTANCE_TYPE,
    };

    // dispatch(setChatHistoryLoader(true));
    let url = `${Config.config1.api_link}/chat-with-data/cwd-delete-session`;
    axios
      .post(url, body)
      .then((response) => {
        if (response?.data?.status === "successful") {
          getNotificationAlertPopUp(
            "Notification",
            payloadObj?.clear_all
              ? "All chats deleted successfully"
              : "Chat deleted successfully",
            "success"
          );

          // Reload chat history API
          // dispatch(getChatTopicHistoryAPI(payloadObj?.chat_list_api_obj));

          // Reset Chat Response
          let obj = {
            persist_data: [],
            data: [],
            total_length: null,
          };
          dispatch(setChatWithDataResponse(obj));
          // Reset selected chat data
          dispatch(setSelectedChatData(null));

          // Delete from state and Update state
          let updatedChatList = payloadObj?.chatTopicsHistory?.data?.map(
            (chat) => {
              chat.content = chat?.content?.filter(
                (d) => d?.session_id !== payloadObj?.session_id
              );
              return chat;
            }
          );
          // to remove empty chat list title from sidebar
          if (updatedChatList?.[0]?.content?.length === 0) {
            updatedChatList?.shift();
          }
          // console.log("updatedChatList", updatedChatList);

          let chat_obj = {
            persist_data: updatedChatList,
            data: updatedChatList,
            total_length: payloadObj?.total_length - 1,
          };
          dispatch(setChattopicsHistory(chat_obj));
        } else {
          response?.data?.message === "p_token missing" ||
          response?.data?.message === "Invalid Token" ||
          response?.data?.message === "User Logged Out"
            ? handleSessionExpiration()
            : getNotificationAlertPopUp(
                "Notification",
                response?.data?.message || "Failed to delete chat. Please try again.",
                "error"
              );
        }
      })
      .catch((error) => {
        console.log("cwd-delete-session API catch error", error);
        getNotificationAlertPopUp(
          "Notification",
          "Failed to delete chat. Please try again.",
          "error"
        );
      });
  };
};

// Set Edit Chat API
export const setRenameChatHistoryAPI = (payloadObj) => {
  let errorMessage;
  return async (dispatch) => {
    let body = {
      p_token: payloadObj?.p_token,
      session_name: payloadObj?.session_name,
      session_id: payloadObj?.session_id,
      instance_type: INSTANCE_TYPE,
    };

    let url = `${Config.config1.api_link}/chat-with-data/cwd-rename-session`;
    axios
      .post(url, body)
      .then((response) => {
        if (response?.data?.status === "successful") {
          getNotificationAlertPopUp(
            "Notification",
            "Chat renamed successfully",
            "success"
          );

          // Reload chat history API
          // dispatch(getChatTopicHistoryAPI(payloadObj?.chat_list_api_obj));

          // Update from state and Update state
          let updatedChatList = payloadObj?.chatTopicsHistory?.data?.map(
            (chat) => {
              chat.content = chat?.content?.map((d) => {
                if (d?.session_id === payloadObj?.session_id) {
                  d.session_name = payloadObj?.session_name;
                }
                return d;
              });
              return chat;
            }
          );
          // console.log("Rename updatedChatList", updatedChatList);

          let chat_obj = {
            persist_data: updatedChatList,
            data: updatedChatList,
            total_length: payloadObj?.total_length - 1,
          };
          dispatch(setChattopicsHistory(chat_obj));
        } else {
          response?.data?.message === "p_token missing" ||
          response?.data?.message === "Invalid Token" ||
          response?.data?.message === "User Logged Out"
            ? handleSessionExpiration()
            : getNotificationAlertPopUp(
                "Notification",
                response?.data?.message,
                "error"
              );
        }
      })
      .catch((error) => {
        console.log("cwd-rename-session API catch error", error);
      });
  };
};

// Get plans list API
export const getPlansListAPI = (payloadObj) => {
  let errorMessage;
  return async (dispatch) => {
    let body = {
      p_token: payloadObj?.p_token,
      instance_type: INSTANCE_TYPE,
    };

    let url = `${Config.config1.api_link}/payments/get-plans`;
    dispatch(setPlansListLoader(true));
    axios
      .post(url, body)
      .then((response) => {
        if (response?.data?.status === "successful") {
          dispatch(setPlansListLoader(false));

          // console.log("response", response?.data?.result);
          dispatch(setPlansList(response?.data?.result?.data));
        } else {
          dispatch(setPlansListLoader(false));
          response?.data?.message === "p_token missing" ||
          response?.data?.message === "Invalid Token" ||
          response?.data?.message === "User Logged Out"
            ? handleSessionExpiration()
            : getNotificationAlertPopUp(
                "Notification",
                response?.data?.message,
                "error"
              );
        }
      })
      .catch((error) => {
        dispatch(setPlansListLoader(false));

        console.log("In catch get-plans error", error);
      });
  };
};

// Set Payment Create User Subscription API
export const setPaymentCreateUserSubscriptionAPI = (payloadObj) => {
  let errorMessage;

  return async (dispatch) => {
    let body = {
      p_token: payloadObj?.p_token,
      plan_id: payloadObj?.plan_id,
      instance_type: INSTANCE_TYPE,
    };

    dispatch(setPaymentProcessLoader(true));
    let url = `${Config.config1.api_link}/payments/create-user-subscription`;
    axios
      .post(url, body)
      .then((response) => {
        if (response?.data?.status === "successful") {
          // console.log("respinse inside", response?.data?.result?.data);
          if (response?.data?.result?.data?.id) {
            const RAZORPAY_KEY_ID = "rzp_test_qUBbaDZsfBeinO";
            const ORDER_ID = response?.data?.result?.data?.id;

            const options = {
              key: RAZORPAY_KEY_ID,
              subscription_id: ORDER_ID,
              name: "CMOverse.ai",
              description: "CMOverse.ai powered by locobuzz",

              handler: function (response) {
                // console.log("In side Success", response);
                let verifyPaymentObj = {
                  p_token: payloadObj?.p_token,
                  subscription_id: response?.razorpay_subscription_id,
                };
                dispatch(setPaymentVerifyUserSubscriptionAPI(verifyPaymentObj));
              },
              modal: {
                ondismiss: function () {
                  // console.log("Razorpay Popup Closed");
                  dispatch(setPaymentProcessLoader(false));
                },
              },
            };
            var rzp1 = new window.Razorpay(options);
            rzp1.on("payment.failed", function (response) {
              // console.log("Payment Failed !", response);
              dispatch(setPaymentProcessLoader(false));
            });

            // Main Start
            rzp1.open();
          }
        } else {
          response?.data?.message === "p_token missing" ||
          response?.data?.message === "Invalid Token" ||
          response?.data?.message === "User Logged Out"
            ? handleSessionExpiration()
            : getNotificationAlertPopUp(
                "Notification",
                response?.data?.message,
                "error"
              );
          dispatch(setPaymentProcessLoader(false));
        }
      })
      .catch((error) => {
        dispatch(setPaymentProcessLoader(false));

        console.log("payments/create-user-subscription API catch error", error);
      });
  };
};

// Set Payment Verify User API
export const setPaymentVerifyUserSubscriptionAPI = (payloadObj) => {
  let errorMessage;

  return async (dispatch) => {
    let body = {
      p_token: payloadObj?.p_token,
      subscription_id: payloadObj?.subscription_id,
      instance_type: INSTANCE_TYPE,
    };

    let url = `${Config.config1.api_link}/payments/verify-user-subscription`;
    dispatch(setPaymentProcessLoader(true));
    axios
      .post(url, body)
      .then((response) => {
        let timer = null;
        if (response?.data?.status === "successful") {
          dispatch(setPaymentProcessLoader(false));
          dispatch(getUserProfileDetailsAPI({ ...payloadObj, force: true }));

          // Just Show Notification Message
          getNotificationAlertPopUp(
            "Notification",
            "Payment Success",
            "success"
          );

          // Redirect to chat page, After getting payment id
          timer = setTimeout(() => {
            window.location = "/chat-with-data";
          }, 1000);
        } else {
          let retry_count = 0;
          // Call Api in 10sec
          // console.log("response", response, "retry_count", retry_count);
          if (retry_count < 3) {
            setTimeout(() => {
              retry_count = retry_count + 1;
              dispatch(setPaymentVerifyUserSubscriptionAPI(payloadObj));
            }, 10000);
          } else {
            response?.data?.message === "p_token missing" ||
            response?.data?.message === "Invalid Token" ||
            response?.data?.message === "User Logged Out"
              ? handleSessionExpiration()
              : getNotificationAlertPopUp(
                  "Notification",
                  response?.data?.message
                    ? response?.data?.message
                    : "Payment will be proccesed later",
                  "error"
                );
            dispatch(setPaymentProcessLoader(false));
          }
        }
        return () => {
          clearTimeout(timer);
        };
      })
      .catch((error) => {
        dispatch(setPaymentProcessLoader(false));

        console.log("payments/verify-order API catch error", error);
      });
  };
};

// Set User Cancel Subscription API
// Req API
export const setCancelSubscriptionAPI = (payloadObj) => {
  let errorMessage;

  return async (dispatch) => {
    let body = {
      p_token: payloadObj?.p_token,
      subscription_id: payloadObj?.subscription_id,
      cancel_at_cycle_end: payloadObj?.cancel_at_cycle_end,
      instance_type: INSTANCE_TYPE,
    };

    let url = `${Config.config1.api_link}/payments/cancel-user-subscription`;
    dispatch(setCancelSubscriptionLoader(true));
    axios
      .post(url, body)
      .then((response) => {
        if (response?.data?.status === "successful") {
          // Just Show Notification Message
          getNotificationAlertPopUp(
            "Notification",
            response?.data?.message,
            "success"
          );

          // Call Get Profile API, to get updated data of user
          let userObj = {
            p_token: payloadObj?.p_token ? payloadObj?.p_token : null,
          };
          dispatch(getUserProfileDetailsAPI({ ...userObj, force: true }));
          dispatch(setCancelSubscriptionLoader(false));
        } else {
          response?.data?.message === "p_token missing" ||
          response?.data?.message === "Invalid Token" ||
          response?.data?.message === "User Logged Out"
            ? handleSessionExpiration()
            : getNotificationAlertPopUp(
                "Notification",
                response?.data?.message,
                "error"
              );
          dispatch(setCancelSubscriptionLoader(false));
        }
      })
      .catch((error) => {
        dispatch(setCancelSubscriptionLoader(false));
        console.log("payments/cancel-subscription API catch error", error);
      });
  };
};

// Set User Delete Account API
// Req API
export const setUserDeleteAccountAPI = (payloadObj) => {
  let errorMessage;

  return async (dispatch) => {
    let body = {
      p_token: payloadObj?.p_token,
      exit_review: payloadObj?.exit_review,
      is_custom_review: payloadObj?.is_custom_review,
      instance_type: INSTANCE_TYPE,
    };

    let url = `${Config.config1.api_link}/auth/delete-profile`;
    dispatch(setDeleteAccountLoader(true));
    axios
      .post(url, body)
      .then((response) => {
        let timer = null;
        if (response?.data?.status === "successful") {
          dispatch(setDeleteAccountLoader(false));
          // Just Show Notification Message
          getNotificationAlertPopUp(
            "Notification",
            response?.data?.result?.data
              ? response?.data?.result?.data
              : "Account deleted successfully",
            "success"
          );

          const keyToKeep = "visitor_uuid";
          const valueToKeep = localStorage.getItem(keyToKeep); // Store the value

          // clear local stoarge
          localStorage.clear();

          if (valueToKeep !== null) {
            localStorage.setItem(keyToKeep, valueToKeep); // Restore the key
          }

          // Redirect to landing page
          timer = setTimeout(() => {
            window.location = "/sign-up";
          }, 1000);
        } else {
          response?.data?.message === "p_token missing" ||
          response?.data?.message === "Invalid Token" ||
          response?.data?.message === "User Logged Out"
            ? handleSessionExpiration()
            : getNotificationAlertPopUp(
                "Notification",
                response?.data?.message,
                "error"
              );
          dispatch(setDeleteAccountLoader(false));
        }
        return () => {
          clearTimeout(timer);
        };
      })
      .catch((error) => {
        dispatch(setDeleteAccountLoader(false));
        console.log("auth/delete-profile API catch error", error);
      });
  };
};

// Set User Sign In API
export const setUserSignInAPI = (payloadObj) => {
  let errorMessage;
  return async (dispatch) => {
    let body = {
      email: payloadObj?.email,
      // captcha_token: payloadObj?.captcha_token,
      // query_id: payloadObj?.query_id,
      instance_type: INSTANCE_TYPE,
    };

    let url = `${Config.config1.api_link}/auth/sign-in`;
    dispatch(setSignUpLoader(true));
    axios
      .post(url, body)
      .then((response) => {
        if (response?.data?.status === "successful") {
          const userId = response.data.user?.id;
          const userEmail = response.data.user?.email;

          if (userId) {
            identifyUser(userId, {
              email: userEmail,
            });
          }
          trackEvent("FR_USER_SIGNED_IN", {
            status: "success",
            sign_in_method: "Email Password",
            logged_in_thru: response?.data?.logged_in_thru,
          });
          dispatch(setSignUpLoader(false));
          dispatch(setSignInThroughFlag(response?.data?.logged_in_thru));
          if (payloadObj?.query_id) {
            localStorage.setItem("show_visited_session", "true");
          }
        } else {
          trackEvent("FR_USER_SIGNED_IN", {
            status: "failed",
            sign_in_method: "Email Password",
            reason: response?.data?.message,
          });
          response?.data?.message === "p_token missing" ||
          response?.data?.message === "Invalid Token" ||
          response?.data?.message === "User Logged Out"
            ? handleSessionExpiration()
            : getNotificationAlertPopUp(
                "Notification",
                response?.data?.message,
                "error"
              );
          dispatch(setSignUpLoader(false));
        }
      })
      .catch((error) => {
        trackEvent("FR_USER_SIGNED_IN", {
          status: "failed",
          sign_in_method: "Email Password",
          reason: error.message,
          http_status: error.response?.status,
        });
        dispatch(setSignUpLoader(false));

        console.log("auth/sign-in API catch error", error);
      });
  };
};

// Set Validate EmailAddress API
export const setValidateEmailAddressAPI = (payloadObj) => {
  let errorMessage;
  return async (dispatch) => {
    let body = {
      user_email: payloadObj?.email,
      p_token: payloadObj?.p_token,
      // captcha_token: payloadObj?.captcha_token,
      instance_type: INSTANCE_TYPE,
    };

    let url = `${Config.config1.api_link}/auth/reset-password`;
    dispatch(setSignUpLoader(true));
    axios
      .post(url, body)
      .then((response) => {
        let timer = null;
        if (response?.data?.status === "successful") {
          getNotificationAlertPopUp(
            "Notification",
            response?.data?.message,
            "success"
          );
          if (payloadObj?.p_token) {
            setTimeout(() => {
              window.location = "/profile";
            }, 2000);
          } else {
            setTimeout(() => {
              window.location = "/sign-in";
            }, 2000);
          }
          dispatch(setSignUpLoader(false));
        } else {
          getNotificationAlertPopUp(
            "Notification",
            response?.data?.message,
            "error"
          );
          dispatch(setSignUpLoader(false));
        }
        return () => {
          clearTimeout(timer);
        };
      })
      .catch((error) => {
        dispatch(setSignUpLoader(false));
        console.log("auth/reset-password API catch error", error);
      });
  };
};

// Set Validate EmailAddress API
export const setCreateNewPasswordAPI = (payloadObj) => {
  let errorMessage;
  return async (dispatch) => {
    let body = {
      ref_id: payloadObj?.ref_id,
      password: payloadObj?.password,
      email: payloadObj?.email,
      p_token: payloadObj?.p_token,
      current_password: payloadObj?.current_password,
      instance_type: INSTANCE_TYPE,
    };

    let url = `${Config.config1.api_link}/auth/set-password`;
    dispatch(setSignUpLoader(true));
    axios
      .post(url, body)
      .then((response) => {
        let timer = null;
        if (response?.data?.status === "successful") {
          if (payloadObj?.profile_flow_flag) {
            getNotificationAlertPopUp(
              "Notification",
              response?.data?.message,
              "success"
            );
          } else {
            getNotificationAlertPopUp(
              "Notification",
              response?.data?.message,
              "success"
            );

            if (payloadObj?.ref_id) {
              // Remove Ref id
              if (payloadObj?.ref_id) {
                localStorage.removeItem("ref_id");
              }

              timer = setTimeout(() => {
                window.location = "/sign-in";
              }, 1000);
            } else {
              timer = setTimeout(() => {
                window.location = payloadObj?.query_id
                  ? `/chat-with-data?query_id=${payloadObj?.query_id}`
                  : payloadObj?.share_id
                  ? `/share/id/${payloadObj?.share_id}`
                  : "/chat-with-data";
              }, 1000);

              localStorage.setItem("create_password_flow", false);
            }
          }

          // Clear ref_id
          localStorage.removeItem("ref_id");
          dispatch(setSignUpLoader(false));
        } else {
          response?.data?.message === "p_token missing" ||
          response?.data?.message === "Invalid Token" ||
          response?.data?.message === "User Logged Out"
            ? handleSessionExpiration()
            : getNotificationAlertPopUp(
                "Notification",
                response?.data?.message,
                "error"
              );
          // Clear ref_id
          // localStorage.removeItem("ref_id");
          dispatch(setSignUpLoader(false));
        }
        return () => {
          clearTimeout(timer);
        };
      })
      .catch((error) => {
        dispatch(setSignUpLoader(false));
        console.log("auth/sign-up API catch error", error);
      });
  };
};

// Set Validate EmailAddress API 1
export const setCreateNewPasswordAPI1 = (payloadObj) => {
  let errorMessage;
  return async (dispatch) => {
    let body = {
      ref_id: payloadObj?.ref_id,
      password: payloadObj?.password,
      email: payloadObj?.email,
      instance_type: INSTANCE_TYPE,
    };

    let url = `${Config.config1.api_link}/auth/set-password`;
    dispatch(setSignUpLoader(true));
    axios
      .post(url, body)
      .then((response) => {
        if (response?.data?.status === "successful") {
          // console.log("Inside Sign Up man", response);
          getNotificationAlertPopUp(
            "Notification",
            response?.data?.message,
            "success"
          );

          // Open OTP Page
          dispatch(setOtpStatusFlag(true));
          dispatch(setSignUpLoader(false));

          // Redirect to Sign In Flow
        } else {
          dispatch(setOtpStatusFlag(false));
          dispatch(setSignUpLoader(false));
          response?.data?.message === "p_token missing" ||
          response?.data?.message === "Invalid Token" ||
          response?.data?.message === "User Logged Out"
            ? handleSessionExpiration()
            : getNotificationAlertPopUp(
                "Notification",
                response?.data?.message,
                "error"
              );
        }
      })
      .catch((error) => {
        dispatch(setOtpStatusFlag(false));
        dispatch(setSignUpLoader(false));

        console.log("auth/sign-up API catch error", error);
      });
  };
};

// Verify Password
export const setUserVerifyPasswordAPI = (payloadObj) => {
  let errorMessage;
  return async (dispatch) => {
    let body = {
      email: payloadObj?.email,
      password: payloadObj?.password,
      // query_id: payloadObj?.query_id,
      instance_type: INSTANCE_TYPE,
    };

    let url = `${Config.config1.api_link}/auth/validate-password`;
    dispatch(setSignUpLoader(true));
    axios
      .post(url, body)
      .then((response) => {
        let timer = null;
        if (response?.data?.status === "successful") {
          timer = setTimeout(() => {
            dispatch(setSignInThroughFlag(null));
          }, 2000);

          getNotificationAlertPopUp(
            "Notification",
            response?.data?.message,
            "success"
          );

          dispatch(setSignUpLoader(false));

          // Store user id
          localStorage.setItem("p_token", response?.data?.p_token);
          localStorage.setItem("credit_count", response?.data?.credit_count);
          localStorage.setItem(
            "is_subscription_active",
            response?.data?.is_subscription_active
          );
          localStorage.removeItem("visitor_id");
          if (payloadObj?.query_id) {
            localStorage.setItem("show_visited_session", "true");
          }

          timer = setTimeout(() => {
            if (payloadObj?.query_id) {
              window.location = `/chat-with-data?query_id=${payloadObj?.query_id}`;
            } else if (payloadObj?.share_id) {
              window.location = `/share/id/${payloadObj?.share_id}`;
            } else {
              window.location = "/chat-with-data";
            }
          }, 1000);
        } else {
          response?.data?.message === "p_token missing" ||
          response?.data?.message === "Invalid Token" ||
          response?.data?.message === "User Logged Out"
            ? handleSessionExpiration()
            : getNotificationAlertPopUp(
                "Notification",
                response?.data?.message,
                "error"
              );
          dispatch(setSignUpLoader(false));
        }
        return () => {
          clearTimeout(timer);
        };
      })
      .catch((error) => {
        dispatch(setSignUpLoader(false));

        console.log("auth/verify-password API catch error", error);
      });
  };
};

// Get Starter Questions API
export const getLandingPageQuestionsAPI = (payloadObj) => {
  let errorMessage;
  return async (dispatch) => {
    let body = {
      p_token: payloadObj?.p_token,
      instance_type: INSTANCE_TYPE,
    };

    dispatch(setStarterQuestionsLoader(true));
    let url = `${Config.config1.api_link}/chat-with-data/landing-page-questions`;
    axios
      .post(url, body)
      .then((response) => {
        if (response?.data?.status === "successful") {
          dispatch(setLandingPageQuestionsList(response?.data?.result));
          dispatch(setStarterQuestionsLoader(false));
        } else {
          dispatch(setStarterQuestionsLoader(false));
          response?.data?.message === "p_token missing" ||
          response?.data?.message === "Invalid Token" ||
          response?.data?.message === "User Logged Out"
            ? handleSessionExpiration()
            : getNotificationAlertPopUp(
                "Notification",
                response?.data?.result,
                "error"
              );
        }
      })
      .catch((error) => {
        dispatch(setStarterQuestionsLoader(false));
        console.log("Started Questions API catch error", error);
      });
  };
};

// Get Delete Account Reson List API
export const getDeleteAccountReasonListAPI = (payloadObj) => {
  let errorMessage;
  return async (dispatch) => {
    let body = {
      p_token: payloadObj?.p_token,
      instance_type: INSTANCE_TYPE,
    };

    dispatch(setStarterQuestionsLoader(true));
    let url = `${Config.config1.api_link}/chat-with-data/delete-account-reasons`;
    axios
      .post(url, body)
      .then((response) => {
        if (response?.data?.status === "successful") {
          dispatch(setDeleteAccountReasonList(response?.data?.result));
          dispatch(setStarterQuestionsLoader(false));
        } else if (response?.data?.error_code == 401) {
          handleSessionExpiration();
          // getNotificationAlertPopUp(
          //   "Notification",
          //   "Session expired. Please sign in again",
          //   "error"
          // );
          // const keyToKeep = "visitor_uuid";
          // const valueToKeep = localStorage.getItem(keyToKeep); // Store the value

          // // clear local stoarge
          // localStorage.clear();

          // if (valueToKeep !== null) {
          //   localStorage.setItem(keyToKeep, valueToKeep); // Restore the key
          // }

          // // Redirect to sign-in page
          // setTimeout(() => {
          //   window.location = "/sign-in";
          // }, 3000);
        } else {
          dispatch(setStarterQuestionsLoader(false));
          response?.data?.message === "p_token missing" ||
          response?.data?.message === "Invalid Token" ||
          response?.data?.message === "User Logged Out"
            ? handleSessionExpiration()
            : getNotificationAlertPopUp(
                "Notification",
                response?.data?.result,
                "error"
              );
        }
      })
      .catch((error) => {
        dispatch(setStarterQuestionsLoader(false));
        console.log("Started Questions API catch error", error);
      });
  };
};

// Get Negative Feedback Reson List API
export const getNegativeFeedbackReasonListAPI = (payloadObj) => {
  let errorMessage;
  return async (dispatch) => {
    let body = {
      // p_token: payloadObj?.p_token,
      instance_type: INSTANCE_TYPE,
    };

    let url = `${Config.config1.api_link}/chat-with-data/feedback-cwd-reasons`;
    axios
      .post(url, body)
      .then((response) => {
        if (response?.data?.status === "successful") {
          dispatch(setNegativeFeedbackReasonList(response?.data?.result));
        } else {
          response?.data?.message === "p_token missing" ||
          response?.data?.message === "Invalid Token" ||
          response?.data?.message === "User Logged Out"
            ? handleSessionExpiration()
            : getNotificationAlertPopUp(
                "Notification",
                response?.data?.result,
                "error"
              );
        }
      })
      .catch((error) => {
        console.log("Started Questions API catch error", error);
      });
  };
};

// Set News Letter API
export const setNewsLetterAPI = (payloadObj) => {
  let errorMessage;
  return async (dispatch) => {
    let body = {
      email: payloadObj?.email,
      instance_type: INSTANCE_TYPE,
    };

    let url = `${Config.config1.api_link}/chat-with-data/newsletter-signup`;
    dispatch(setSignUpLoader(true));
    axios
      .post(url, body)
      .then((response) => {
        if (
          response?.data?.status === "successful" ||
          response?.data?.status === "success"
        ) {
          dispatch(setSignUpLoader(false));

          getNotificationAlertPopUp(
            "Notification",
            response?.data?.message,
            "success"
          );
        } else {
          dispatch(setSignUpLoader(false));
          response?.data?.message === "p_token missing" ||
          response?.data?.message === "Invalid Token" ||
          response?.data?.message === "User Logged Out"
            ? handleSessionExpiration()
            : getNotificationAlertPopUp(
                "Notification",
                response?.data?.message,
                "error"
              );
        }
      })
      .catch((error) => {
        dispatch(setSignUpLoader(false));

        console.log("newsletter-signup API catch error", error);
      });
  };
};

// Set Search Chat API
export const getGlobalSearchChatAPI = (payloadObj) => {
  let errorMessage;
  return async (dispatch) => {
    let body = {
      search_text: payloadObj?.search_text,
      p_token: payloadObj?.p_token,
      utcoffset: getUTCOffset(),
      instance_type: INSTANCE_TYPE,
    };

    dispatch(setGlobalSearchChatLoader(true));
    let url = `${Config.config1.api_link}/chat-with-data/global-search`;
    axios
      .post(url, body)
      .then((response) => {
        if (response?.data?.status === "successful") {
          dispatch(setGlobalSearchChatLoader(false));
          let topicHistoryList =
            response?.data?.result === "No results found."
              ? response?.data?.result
              : response?.data?.result?.data;

          dispatch(setGlobalSearchChatList(topicHistoryList));
        } else {
          dispatch(setGlobalSearchChatLoader(false));
          response?.data?.message === "p_token missing" ||
          response?.data?.message === "Invalid Token" ||
          response?.data?.message === "User Logged Out"
            ? handleSessionExpiration()
            : getNotificationAlertPopUp(
                "Notification",
                response?.data?.message,
                "error"
              );
        }
      })
      .catch((error) => {
        dispatch(setGlobalSearchChatLoader(false));
        console.log("global-search API catch error", error);
      });
  };
};

// Get Share link API
export const getShareChatLink = (payloadObj, type) => {
  let errorMessage;
  return async (dispatch) => {
    let body = {
      p_token: payloadObj?.p_token,
      session_id: payloadObj?.session_id,
      query_id: payloadObj?.query_id,
      artifact_id: payloadObj?.artifact_id,
      instance_type: INSTANCE_TYPE,
    };

    let url = `${Config.config1.api_link}/share/create-share-link`;
    axios
      .post(url, body)
      .then((response) => {
        if (response?.data?.status === "success") {
          let newSharableLink = `${
            window.location.origin +
            "/share/id/" +
            response?.data?.share_id +
            `?type=${type === "share_artifact" ? "artifact" : "chat"}`
          }`;
          dispatch(
            setShareChatID({
              id: response?.data?.share_id,
              link: newSharableLink,
            })
          );
        } else {
          response?.data?.message === "p_token missing" ||
          response?.data?.message === "Invalid Token" ||
          response?.data?.message === "User Logged Out"
            ? handleSessionExpiration()
            : getNotificationAlertPopUp(
                "Notification",
                response?.data?.result,
                "error"
              );
        }
      })
      .catch((error) => {
        console.log("Started Questions API catch error", error);
      });
  };
};

// Get Shared chat history
export const getSharedTopicChatsAPI = (payloadObj) => {
  let errorMessage;
  return async (dispatch) => {
    let body = {
      share_id: payloadObj?.share_id,
      utcoffset: getUTCOffset(),
      instance_type: INSTANCE_TYPE,
    };

    if (payloadObj?.offset === 0) {
      dispatch(setTopicAnswerLoader(true));
    }
    let url = `${Config.config1.api_link}/share/id/${payloadObj?.share_id}`;
    // True the flag
    if (payloadObj?.offset > 0) {
      // console.log("INSIDNE MEEME");
      // dispatch(setTopicAnswerOnScrollLoader(true));
    }
    axios
      .post(url, body)
      .then((response) => {
        if (response?.data?.status === "success") {
          if (payloadObj?.offset === 0 || true) {
            let topicChatHistory = response?.data?.result?.data;
            // Map and format anser and chart
            topicChatHistory = topicChatHistory?.map((d) => {
              if (d) {
                let newAns = d?.answer;
                let newChart = null;

                var text = newAns;
                var html = convertMarkdownToHTML(text);
                newAns = html;

                // Handle new artifact structure
                if (d?.artifact) {
                  try {
                    // Parse the artifact JSON string
                    let artifactData = typeof d.artifact === 'string' ? JSON.parse(d.artifact) : d.artifact;
                    newChart = artifactData;
                    d.chartComp = artifactData;
                  } catch (error) {
                    console.error('Error parsing artifact data:', error);
                    newChart = null;
                  }
                }
                // Fallback to highcharts_config_json if artifact is not available
                else if (d?.highcharts_config_json) {
                  newChart = d.highcharts_config_json;
                  // Handle both formats: native JSON array or legacy string
                  if (typeof newChart === 'string' && newChart.length) {
                    let updatedString = newChart.replace(/'/g, '"');
                    updatedString = updatedString.replace(/\bFalse\b/g, "false");
                    updatedString = updatedString.replace(/\bTrue\b/g, "true");

                    try {
                      newChart = JSON.parse(updatedString);
                    } catch (error) {
                      console.error('Error parsing highcharts_config_json:', error);
                      newChart = null;
                    }
                  }
                }

                // Modifying here answer and chart
                d.answer = newAns;
                d.highcharts_config_json = newChart;

                // Strip [CHART:...] markers from displayed answer
                if (d.answer) {
                  d.answer = d.answer.replace(/\[CHART:[^\]]+\]/g, '');
                }

                // Reconstruct content_segments from [CHART:id] or [CHART:alias] markers in answer
                if (Array.isArray(newChart) && newChart.length > 0 && text) {
                  const chartMap = {};
                  newChart.forEach(c => {
                    if (c.id) chartMap[c.id] = c;
                    if (c._alias) chartMap[c._alias] = c;
                  });

                  const parts = text.split(/\[CHART:([^\]]+)\]/);

                  const segments = [];
                  for (let i = 0; i < parts.length; i++) {
                    if (i % 2 === 0) {
                      const trimmed = parts[i].trim();
                      if (trimmed) {
                        segments.push({
                          type: "text",
                          content: trimmed,
                          html: convertMarkdownToHTML(trimmed),
                        });
                      }
                    } else {
                      const chartId = parts[i];
                      const chartConfig = chartMap[chartId];
                      if (chartConfig) {
                        segments.push({
                          type: "chart",
                          chartId: chartConfig.id,
                          chartTitle: chartConfig.description || chartConfig.config?.title?.text || "Chart",
                          charts: [chartConfig],
                        });
                      }
                    }
                  }

                  if (segments.some(s => s.type === 'chart')) {
                    d.content_segments = segments;
                  }
                }
              }
              return d;
            });

            let obj = {
              persist_data: topicChatHistory,
              data: topicChatHistory,
              total_length: response?.data?.result?.data,
            };
            dispatch(setChatWithDataResponse(obj));
            if (payloadObj?.offset === 0) {
              dispatch(setTopicAnswerLoader(false));
            }

            // Update Brand Here
            let chat =
              response?.data?.result?.data?.[
                response?.data?.result?.data?.length - 1
              ];
            let compBrandsList;
            if (chat?.comp_brand_list?.length) {
              compBrandsList = payloadObj?.brands?.filter(
                (d) => d?.brand_id === chat?.brand_list?.[0]?.brand_id
              );
            }

            let compBrands = {
              columns: [
                {
                  group: false,
                  name: chat?.brand_list?.[0]?.brand_id
                    ? chat?.brand_list?.[0]?.brand_id
                    : null,
                  type: "include",
                  brand_friendly_name: compBrandsList?.[0]?.brand_friendly_name, // Neeed these thinhg
                  brand_color: "#002342",
                  brand_group_name: false,
                  competitor: true,
                  competitorList: chat?.comp_brand_list,
                },
              ],
              attribute: "BrandID",
              type: "varchar",
            };

            let selectedBrand = chat?.comp_brand_list?.length
              ? compBrands
              : chat?.brandgroups?.length
              ? chat?.brandgroups
              : chat?.brand_list;

            dispatch(setBrandsInChatWithData(selectedBrand));

            // Update Duration here
            let selectedDuration = {
              from: chat?.start_date ? chat?.start_date : null,
              to: chat?.end_date ? chat?.end_date : null,
            };
            dispatch(setDurationInChatWithData(selectedDuration));
          } else {
            let oldData = payloadObj?.chatWithDataRes?.data;
            let topicChatHistory = response?.data?.shared_chat;
            // Map and format anser and chart
            topicChatHistory = topicChatHistory?.map((d) => {
              if (d) {
                let newAns = d?.answer;
                let newChart = null;

                var text = newAns;
                var html = convertMarkdownToHTML(text);
                newAns = html;

                // Handle new artifact structure
                if (d?.artifact) {
                  try {
                    // Parse the artifact JSON string
                    let artifactData = typeof d.artifact === 'string' ? JSON.parse(d.artifact) : d.artifact;
                    newChart = artifactData;
                    d.chartComp = artifactData;
                  } catch (error) {
                    console.error('Error parsing artifact data:', error);
                    newChart = null;
                  }
                }
                // Fallback to highcharts_config_json if artifact is not available
                else if (d?.highcharts_config_json) {
                  newChart = d.highcharts_config_json;
                  // Handle both formats: native JSON array or legacy string
                  if (typeof newChart === 'string' && newChart.length) {
                    let updatedString = newChart.replace(/'/g, '"');
                    updatedString = updatedString.replace(/\bFalse\b/g, "false");
                    updatedString = updatedString.replace(/\bTrue\b/g, "true");

                    try {
                      newChart = JSON.parse(updatedString);
                    } catch (error) {
                      console.error('Error parsing highcharts_config_json:', error);
                      newChart = null;
                    }
                  }
                }

                // Modifying here answer and chart
                d.answer = newAns;
                d.highcharts_config_json = newChart;

                // Strip [CHART:...] markers from displayed answer
                if (d.answer) {
                  d.answer = d.answer.replace(/\[CHART:[^\]]+\]/g, '');
                }

                // Reconstruct content_segments from [CHART:id] or [CHART:alias] markers in answer
                if (Array.isArray(newChart) && newChart.length > 0 && text) {
                  const chartMap = {};
                  newChart.forEach(c => {
                    if (c.id) chartMap[c.id] = c;
                    if (c._alias) chartMap[c._alias] = c;
                  });

                  const parts = text.split(/\[CHART:([^\]]+)\]/);

                  const segments = [];
                  for (let i = 0; i < parts.length; i++) {
                    if (i % 2 === 0) {
                      const trimmed = parts[i].trim();
                      if (trimmed) {
                        segments.push({
                          type: "text",
                          content: trimmed,
                          html: convertMarkdownToHTML(trimmed),
                        });
                      }
                    } else {
                      const chartId = parts[i];
                      const chartConfig = chartMap[chartId];
                      if (chartConfig) {
                        segments.push({
                          type: "chart",
                          chartId: chartConfig.id,
                          chartTitle: chartConfig.description || chartConfig.config?.title?.text || "Chart",
                          charts: [chartConfig],
                        });
                      }
                    }
                  }

                  if (segments.some(s => s.type === 'chart')) {
                    d.content_segments = segments;
                  }
                }
              }
              return d;
            });

            let mergedData = [...topicChatHistory, ...oldData];
            let obj = {
              persist_data: mergedData,
              data: mergedData,
              total_length: response?.data?.result?.total_chats,
            };
            dispatch(setChatWithDataResponse(obj));
            if (payloadObj?.offset === 0) {
              dispatch(setTopicAnswerLoader(false));
            }
          }
          let obj = {
            chatTopicsHistory: payloadObj?.chatTopicsHistory,
            session_id:
              response?.data?.result?.data?.[0]?.session_id ||
              payloadObj?.session_id,
            question:
              response?.data?.result?.data?.[0]?.question ||
              payloadObj?.question,
            answer: response?.data?.result?.data?.[0]?.answer,
            p_token: payloadObj?.p_token ? payloadObj?.p_token : null,
            shared_case: true,
          };
          // DISABLED: Session name is now received in the streaming response
          // dispatch(getNewChatNameAPI(obj));
        } else {
          let obj = {
            persist_data: [],
            data: [],
            total_length: null,
          };
          dispatch(setChatWithDataResponse(obj));
          if (payloadObj?.offset === 0) {
            dispatch(setTopicAnswerLoader(false));
          }
        }
      })
      .catch((error) => {
        console.log("In catch getTopicChatsAPI error", error);
        if (payloadObj?.offset === 0) {
          dispatch(setTopicAnswerLoader(false));
        }

        // Dont Show Message Now
        // if (error.message !== "Request aborted") {
        //   callNotification(null, "error");
        // }
      });
  };
};
// /share/duplicate-shared-chat

// Duplicate share chat when first time user ask in shared chat
export const duplicateSharedChatApi = (payloadObj) => {
  let errorMessage;
  return async (dispatch) => {
    let body = {
      p_token: payloadObj?.p_token,
      share_id: payloadObj?.share_id,
      visitor_id: payloadObj?.p_token ? null : payloadObj?.visitor_id,
      instance_type: INSTANCE_TYPE,
    };

    let url = `${Config.config1.api_link}/share/duplicate-shared-chat`;
    axios
      .post(url, body)
      .then((response) => {
        if (response?.data?.status === "success") {
          let new_session_id = response?.data?.new_session_id;
          let updatedPayload = { ...payloadObj };
          updatedPayload.session_id = new_session_id;
          dispatch(getChatResponseAPI(updatedPayload, true));
          // to get latest chat history when user starts chat in shared case
          // let payLoad = {
          //   offset: payloadObj?.offset,
          //   // session_id: payloadObj?.session_id,
          //   p_token: payloadObj?.p_token,
          // };
          // dispatch(getChatTopicHistoryAPI(payLoad));
        } else {
          response?.data?.message === "p_token missing" ||
          response?.data?.message === "Invalid Token" ||
          response?.data?.message === "User Logged Out"
            ? handleSessionExpiration()
            : getNotificationAlertPopUp(
                "Notification",
                response?.data?.result,
                "error"
              );
        }
      })
      .catch((error) => {
        console.log("Started Questions API catch error", error);
      });
  };
};

export const getIPAddressAPI = async () => {
  await axios
    .get("https://ipapi.co/json/")
    .then((res) => {
      localStorage.setItem("ipAddress", res?.data?.ip);
      localStorage.setItem("country_code", res?.data?.country_code || "IN");
      localStorage.setItem("country_name", res?.data?.country_name || "India");
    })
    .catch((error) => {
      console.log("Get Ip Address Error — defaulting to India", error);
      if (!localStorage.getItem("country_code")) {
        localStorage.setItem("country_code", "IN");
        localStorage.setItem("country_name", "India");
      }
    });
};

// Get Chat Event Stream API - NEW
export const getChartArtifactStreamResponse = (
  payloadObj,
  generated_query_id
) => {
  return async (dispatch) => {
    const sessionKey = payloadObj?.session_id || payloadObj?.temp_session_id || 'default';
    const controllers = getSessionControllers(sessionKey);
    if (controllers.chatArtifact) {
      controllers.chatArtifact.abort();
    }
    controllers.chatArtifact = new AbortController();
    const { signal } = controllers.chatArtifact;
    dispatch(setChartsArtifactLoader(true));
    let url = `${Config.config1.api_link}/chat-with-data/chat-stream-artifact`;
    let body = {
      p_token: payloadObj?.p_token,
      query_id: generated_query_id,
      instance_type: INSTANCE_TYPE,
    };

    trackEvent("FR_CHAT_ARTIFACT_REQUEST", {
      p_token: payloadObj?.p_token,
      query_id: generated_query_id,
      session_id: payloadObj?.session_id,
      is_logged_in: !!payloadObj?.p_token,
    });

    axios
      .post(url, body, { signal })
      .then((response) => {        
        if (response?.data?.status === "successful") {
          if (payloadObj?.chatWithDataRes?.data?.length) {
            trackEvent("FR_CHAT_ARTIFACT_SUCCESS", {
              p_token: payloadObj?.p_token,
              query_id: generated_query_id,
              session_id: payloadObj?.session_id,
              artifact_id: response?.data?.artifact_uuid,
              has_artifact_data: !!response?.data?.artifact_data,
            });
            let chatWithData = payloadObj?.chatWithDataRes?.data?.map((d) => {
              // chartResponseLoader = d?.loader;

              if (d?.query_id === generated_query_id) {
                // Store the artifact_data for chart rendering
                d.artifact_data = response?.data?.artifact_data;
                
                // Set artifact as JSON string for chart rendering logic
                d.artifact = JSON.stringify(response?.data || {});
                
                // Keep chartComp for backward compatibility (if needed for other chart types)
                d.chartComp = typeof response?.data?.artifact_data === 'string' 
                  ? response?.data?.artifact_data 
                  : JSON.stringify(response?.data?.artifact_data || '');
                d.artifact_id = response?.data?.artifact_uuid;
                d.chartCompLoader = false;
                localStorage.setItem(
                  "artifactId",
                  response?.data?.artifact_uuid
                );
              }
              return d;
            });

            let obj = {
              persist_data: chatWithData,
              data: chatWithData,
              total_length: null,
            };
            dispatch(setChatWithDataResponse(obj));
            dispatch(setChartsArtifactLoader(false));
          }
        } else if (response?.data?.status === "error") {
          trackEvent("FR_CHAT_ARTIFACT_FAILURE", {
            p_token: payloadObj?.p_token,
            query_id: generated_query_id,
            session_id: payloadObj?.session_id,
            error_type: "server_error",
            error_message: response?.data?.message,
            response_status: response?.data?.status,
          });
          // dispatch(setChartsArtifactLoader(false));
          if (payloadObj?.chatWithDataRes?.data?.length) {
            let chatWithData = payloadObj?.chatWithDataRes?.data?.map((d) => {
              // chartResponseLoader = d?.loader;

              if (d?.query_id === generated_query_id) {
                // Store the artifact_data even for error responses so status can be checked
                d.artifact_data = response?.data?.artifact_data;
                
                // Set artifact as JSON string for error responses too
                d.artifact = JSON.stringify(response?.data || {});
                
                d.chartCompLoader = false;
              }
              return d;
            });

            let obj = {
              persist_data: chatWithData,
              data: chatWithData,
              total_length: null,
            };
            dispatch(setChatWithDataResponse(obj));
            dispatch(setChartsArtifactLoader(false));
          }
          console.error(
            "❌ Error fetching artifacts data:",
            response?.data?.message
          );
        }
      })
      .catch((error) => {
        trackEvent("FR_CHAT_ARTIFACT_FAILURE", {
          p_token: payloadObj?.p_token,
          query_id: generated_query_id,
          session_id: payloadObj?.session_id,
          error_type: "catch_block",
          error_message: error.message,
          error_code: error.code,
        });
        dispatch(setChartsArtifactLoader(false));
        console.error("❌ Error fetching artifacts data:", error);
      });
  };
};

export const checkEmailValidityAPI = async (payloadObj) => {
  let body = {
    p_token: payloadObj?.p_token,
    check_email: payloadObj?.email,
    instance_type: INSTANCE_TYPE,
  };

  let url = `${Config.config1.api_link}/auth/check-refferal`;

  try {
    const response = await axios.post(url, body);

    return {
      isValid: response?.data?.status === "successful",
      message: response?.data?.message || "",
    };
  } catch (error) {
    console.error("Inside /check-refferal Catch Error", error);

    return {
      isValid: false,
      message: "",
    };
  }
};

export const checkAndUpdateCountry = async (payloadObj) => {
  let body = {
    p_token: payloadObj?.p_token,
    country_code: payloadObj?.country_code,
    instance_type: INSTANCE_TYPE,
  };

  let url = `${Config.config1.api_link}/auth/set-region`;

  try {
    const response = await axios.post(url, body);
    if (response?.data?.status === "successful") {
      const matchedCountry = updatedCountriesList.find(
        (country) => country.code === payloadObj?.country_code
      );

      if (matchedCountry) {
        localStorage.setItem("selectedCountry", matchedCountry.name);
        localStorage.setItem("selectedCountryCode", matchedCountry.code);
      }
    }
    return response;
  } catch (error) {
    console.error("Inside /checkAndUpdateCountry Catch Error", error);
    return null;
  }
};

// Phone Verification - Send OTP
// ⚠️ TOGGLE FLAG: Change this to switch between APIs ⚠️
const USE_SIGNUP_API = false; // Set to false to use /auth/sign-in API instead

export const sendPhoneVerificationOTPAPI = (payloadObj) => {
  return async (dispatch) => {
    let body, url;
    
    if (USE_SIGNUP_API) {
      // OPTION 1: Use /auth/sign-up API - sends OTP to both email and WhatsApp
      body = {
        email: payloadObj?.email,
        phone_number: payloadObj?.phone_number,
        country_code: payloadObj?.country_code,
        first_name: payloadObj?.first_name || "",
        last_name: payloadObj?.last_name || "",
        password: payloadObj?.password || "",
        instance_type: INSTANCE_TYPE,
      };
      url = `${Config.config1.api_link}/auth/sign-up`;
    } else {
      // OPTION 2: Use /auth/sign-in API - sends OTP to WhatsApp (only needs email)
      body = {
        email: payloadObj?.email,
        instance_type: INSTANCE_TYPE,
      };
      url = `${Config.config1.api_link}/auth/sign-in`;
    }

    dispatch(setSignUpLoader(true));
    
    trackEvent("FR_SEND_PHONE_OTP_REQUEST", {
      api_used: USE_SIGNUP_API ? "sign-up" : "sign-in",
      context: "profile_phone_verification",
    });

    axios
      .post(url, body)
      .then((response) => {
        dispatch(setSignUpLoader(false));
        
        if (response?.data?.status === "successful") {
          trackEvent("FR_SEND_PHONE_OTP_SUCCESS", {
            api_used: USE_SIGNUP_API ? "sign-up" : "sign-in",
          });
          
          getNotificationAlertPopUp(
            "Notification",
            "OTP sent to your phone number",
            "success"
          );
          
          if (payloadObj?.onSuccess) {
            payloadObj.onSuccess();
          }
        } else {
          trackEvent("FR_SEND_PHONE_OTP_FAILURE", {
            api_used: USE_SIGNUP_API ? "sign-up" : "sign-in",
            error_type: "server_error",
            error_message: response?.data?.message,
          });
          
          getNotificationAlertPopUp(
            "Notification",
            response?.data?.message || "Failed to send OTP",
            "error"
          );
        }
      })
      .catch((error) => {
        dispatch(setSignUpLoader(false));
        
        trackEvent("FR_SEND_PHONE_OTP_FAILURE", {
          api_used: USE_SIGNUP_API ? "sign-up" : "sign-in",
          error_type: "catch_block",
          error_message: error.message,
        });
        
        console.error("Send Phone OTP API Error:", error);
        getNotificationAlertPopUp(
          "Notification",
          "Failed to send OTP. Please try again.",
          "error"
        );
      });
  };
};

// Phone Verification - Verify OTP using existing validate-otp API
export const verifyPhoneOTPAPI = (payloadObj) => {
  return async (dispatch) => {
    // Use existing /auth/validate-otp API
    let body = {
      email: payloadObj?.email,
      otp: payloadObj?.otp,
      instance_type: INSTANCE_TYPE,
    };

    let url = `${Config.config1.api_link}/auth/validate-otp`;
    dispatch(setOtpValidateLoader(true));

    trackEvent("FR_VERIFY_PHONE_OTP_REQUEST", {
      otp_length: payloadObj?.otp?.length,
    });

    axios
      .post(url, body)
      .then((response) => {
        dispatch(setOtpValidateLoader(false));
        
        if (response?.data?.status === "successful") {
          trackEvent("FR_VERIFY_PHONE_OTP_SUCCESS", {});
          
          getNotificationAlertPopUp(
            "Notification",
            "Phone number verified successfully",
            "success"
          );
          
          // Refresh user profile
          let p_token = localStorage.getItem("p_token");
          if (p_token) {
            let userObj = { p_token: p_token };
            dispatch(getUserProfileDetailsAPI(userObj));
          }
          
          if (payloadObj?.onSuccess) {
            payloadObj.onSuccess();
          }
        } else {
          trackEvent("FR_VERIFY_PHONE_OTP_FAILURE", {
            email: payloadObj?.email,
            error_type: "server_error",
            error_message: response?.data?.message,
          });
          
          getNotificationAlertPopUp(
            "Notification",
            response?.data?.message || "Invalid OTP. Please try again.",
            "error"
          );
        }
      })
      .catch((error) => {
        dispatch(setOtpValidateLoader(false));
        
        trackEvent("FR_VERIFY_PHONE_OTP_FAILURE", {
          email: payloadObj?.email,
          error_type: "catch_block",
          error_message: error.message,
        });
        
        console.error("Verify Phone OTP API Error:", error);
        getNotificationAlertPopUp(
          "Notification",
          "Failed to verify OTP. Please try again.",
          "error"
        );
      });
  };
};

// Mobile Number Verification - Send OTP to mobile number
export const sendMobileVerificationOTPAPI = (payloadObj) => {
  return async (dispatch) => {
    let body = {
      new_phone_number: payloadObj?.new_phone_number,
      country_code: payloadObj?.country_code,
      p_token: payloadObj?.p_token,
      instance_type: INSTANCE_TYPE,
    };

    let url = `${Config.config1.api_link}/auth/verify-mobile-number`;
    dispatch(setSignUpLoader(true));
    
    trackEvent("FR_SEND_MOBILE_OTP_REQUEST", {
      country_code: payloadObj?.country_code,
      context: "profile_mobile_verification",
    });

    axios
      .post(url, body)
      .then((response) => {
        dispatch(setSignUpLoader(false));
        
        if (response?.data?.success) {
          trackEvent("FR_SEND_MOBILE_OTP_SUCCESS", {
            country_code: payloadObj?.country_code,
          });
          
          getNotificationAlertPopUp(
            "Notification",
            response?.data?.message || "OTP sent to your mobile number",
            "success"
          );
          
          if (payloadObj?.onSuccess) {
            payloadObj.onSuccess(response?.data?.otp);
          }
        } else {
          trackEvent("FR_SEND_MOBILE_OTP_FAILURE", {
            country_code: payloadObj?.country_code,
            error_type: "server_error",
            error_message: response?.data?.message,
          });
          
          getNotificationAlertPopUp(
            "Notification",
            response?.data?.message || "Failed to send OTP",
            "error"
          );
          
          if (payloadObj?.onError) {
            payloadObj.onError(response?.data?.message);
          }
        }
      })
      .catch((error) => {
        dispatch(setSignUpLoader(false));
        
        trackEvent("FR_SEND_MOBILE_OTP_FAILURE", {
          country_code: payloadObj?.country_code,
          error_type: "catch_block",
          error_message: error.message,
        });
        
        console.error("Send Mobile OTP API Error:", error);
        getNotificationAlertPopUp(
          "Notification",
          "Failed to send OTP. Please try again.",
          "error"
        );
        
        if (payloadObj?.onError) {
          payloadObj.onError(error.message);
        }
      });
  };
};

// Mobile Number Verification - Validate OTP
export const validateMobileOTPAPI = (payloadObj) => {
  return async (dispatch) => {
    let body = {
      new_phone_number: payloadObj?.new_phone_number,
      otp: payloadObj?.otp,
      instance_type: INSTANCE_TYPE,
    };

    let url = `${Config.config1.api_link}/auth/validate-otp`;
    dispatch(setOtpValidateLoader(true));

    trackEvent("FR_VALIDATE_MOBILE_OTP_REQUEST", {
      otp_length: payloadObj?.otp?.length,
    });

    return axios
      .post(url, body)
      .then((response) => {
        dispatch(setOtpValidateLoader(false));
        
        if (response?.data?.success) {
          trackEvent("FR_VALIDATE_MOBILE_OTP_SUCCESS", {});
          
          getNotificationAlertPopUp(
            "Notification",
            response?.data?.message || "Mobile number verified successfully",
            "success"
          );
          
          if (payloadObj?.onSuccess) {
            payloadObj.onSuccess();
          }
          
          return { success: true, data: response?.data };
        } else {
          trackEvent("FR_VALIDATE_MOBILE_OTP_FAILURE", {
            error_type: "server_error",
            error_message: response?.data?.message,
          });
          
          getNotificationAlertPopUp(
            "Notification",
            response?.data?.message || "Invalid OTP. Please try again.",
            "error"
          );
          
          if (payloadObj?.onError) {
            payloadObj.onError(response?.data?.message);
          }
          
          return { success: false, message: response?.data?.message };
        }
      })
      .catch((error) => {
        dispatch(setOtpValidateLoader(false));
        
        trackEvent("FR_VALIDATE_MOBILE_OTP_FAILURE", {
          error_type: "catch_block",
          error_message: error.message,
        });
        
        console.error("Validate Mobile OTP API Error:", error);
        getNotificationAlertPopUp(
          "Notification",
          "Failed to verify OTP. Please try again.",
          "error"
        );
        
        if (payloadObj?.onError) {
          payloadObj.onError(error.message);
        }
        
        return { success: false, message: error.message };
      });
  };
};
